export default {
  "common.login": "INLOGGEN",
  "common.logout": "UITLOGGEN",
  "common.logged-out": "Je bent uitgelogd.",
  "common.log-in-portal": "Gebruik de portal om in te loggen.",
  "common.undo": "ongedaan maken",
  "common.unknown": "onbekend",
  "common.save-changes": "Wijzigingen opslaan",
  "common.cancel": "Annuleren",
  "common.accept": "Accepteren",
  "common.no-matching-tags": "Geen overeenkomende tags",
  "common.create-tag": "Maak een nieuwe tag",
  "common.subscriptionRequired": "Je abonnement is verlopen, ga naar je account om je abonnement te vernieuwen.",
  "common.alreadySubscribed": "Je bent al geabonneerd.",
  "common.loading": "Laden...",
  "common.notFound": "Niet gevonden",
  "common.done": "Klaar",
  "common.copy": "Kopiëren",
  "common.copied": "Gekopieerd",
  "common.next": "Volgende",
  "common.back": "Terug",
  "common.close": "Sluiten",
  "common.open": "Openen",
  "common.save": "Opslaan",
  "common.hide": "Verbergen",
  "common.retry": "Opnieuw",
  "common.refresh": "Vernieuwen",
  "common.save-template": "Opslaan als template",
  "common.choose": "Kies",
  "common.apply": "Toepassen",
  "common.delete": "Verwijderen",
  "common.reload": "Herladen",

  "app.update_available": "Er is een nieuwere versie van de app beschikbaar.",
  "app.update_reload": "Nu herladen",

  "menu.invitations": "UITNODIGINGEN",
  "menu.portal": "PORTAAL",
  "menu.faq": "VEELGESTELDE VRAGEN",
  "menu.voicePlans": "Voice Plans",
  "menu.book": "Boeken",
  "menu.playlist": "Afspeellijst",
  "menu.portal_lower": "Oefeningenportaal",
  "menu.menu": "Menu",
  "menu.language": "Taal",
  "menu.settings": "Instellingen",
  "menu.home": "Home",
  "menu.back": "Terug",
  "menu.subscriptionRequired.tooltip": "Abonnement vereist voor toegang tot deze functie",
  "menu.portal.description": "Alle zangoefeningen uit de Universal Voice Guide kun je hier afspelen",
  "menu.voicePlans.description": "Stel hier een lesplan samen met zangoefeningen voor jezelf of voor je studenten",
  "menu.playlist.description": "Maak hier een afspeellijst van je favoriete oefeningen zodat deze achter elkaar afspelen tijdens het trainen",
  "menu.book.description": "Digitale PDF-versies van de Universal Voice Guide in verschillende talen",
  "menu.account_and_subscription": "Account en abonnement",
  "menu.organization": "Organisatie Licentie",
  "menu.pricing": "PRIJZEN",
  "menu.organization_pricing": "Organisatie Licenties",

  "voicePlanList.students": "Studenten",
  "voicePlanList.teachers": "Leraren",
  "voicePlanList.voiceplans": "Voice Plans",
  "voicePlanList.no-voiceplans": "Je hebt nog geen Voice Plans!",
  "voicePlanList.toast.delete-voiceplan": "{{name}} verwijderd",
  "voicePlanList.all": "Alle",
  "voicePlanList.add-new-voiceplan.a": "Je kunt nieuwe Voice Plans voor jezelf of een student toevoegen door op de plusknop te klikken",
  "voicePlanList.add-new-voiceplan.b": "in de rechterbenedenhoek.",
  "voicePlanList.manage-categories": "Tags beheren",
  "voicePlanList.add-category": "Categorie toevoegen",
  "voicePlanList.edit-category": "Categorie bewerken",
  "voicePlanList.category-name": "Categorienaam",
  "voicePlanList.category-name-placeholder": "bijv. Mijn Studenten",
  "voicePlanList.category-tags": "Tags",
  "voicePlanList.category-match-rule": "Matchingsregel",
  "voicePlanList.match-all": "Alle tags moeten matchen",
  "voicePlanList.match-any": "Elke tag moet matchen",
  "voicePlanList.filter": "Filter",
  "voicePlanList.filter-and-settings": "Filter & instellingen",
  "voicePlanList.categories": "Categorieen",
  "voicePlanList.manage-tags": "Tags beheren",
  "voicePlanList.delete-tag": "Tag verwijderen",
  "voicePlanList.delete-tag-description": "Klik op de X op een tag om deze te verwijderen uit alle voice plans.",
  "voicePlanList.tag-deleted-undo": "Tag verwijderd. Ongedaan maken?",
  "voicePlanList.protected-tag": "Systeemtag gebaseerd op de rol van het voice plan. Deze kan niet worden verwijderd.",
  "voicePlanList.hide-system-tags": "Systeemtags verbergen",
  "voicePlanList.set-color": "Tagkleur instellen",
  "voicePlanList.edit-tag-label": "Voer een weergavenaam in voor deze tag:",
  "voicePlanList.show-more": "Toon meer",
  "voicePlanList.show-less": "Toon minder",

  "playlistList.create-prompt": "Voer een naam in voor de afspeellijst:",
  "playlistList.rename-prompt": "Afspeellijst hernoemen",
  "playlistList.delete-confirm": "Weet je zeker dat je deze afspeellijst wilt verwijderen?",
  "playlistList.no-playlists": "Nog geen afspeellijsten",
  "playlistList.add-new-playlist.a": "Klik",
  "playlistList.add-new-playlist.b": "om een afspeellijst te maken",

  "playlistView.edit": "Bewerken",
  "playlistView.playback": "Afspeelmodus",
  "playlistView.playlist-items": "Afspeellijst Items",
  "playlistView.no-items": "Geen items in afspeellijst",
  "playlistView.search-exercises": "Zoek Oefeningen",
  "playlistView.search-placeholder": "Zoek oefeningen...",
  "playlistView.play": "Afspelen",
  "playlistView.stop": "Stoppen",
  "playlistView.add-exercise": "Oefening toevoegen",
  "playlistView.add-tts": "TTS toevoegen",
  "playlistView.add-recording": "Stem toevoegen",
  "playlistView.playlist-name": "Afspeellijst naam",
  "playlistView.by": "door",
  "playlistView.is-private": "Deze afspeellijst is privé of door de auteur verwijderd.",
  "playlistView.back-to-library": "Terug",
  "playlistView.add-to-playlist": "Toevoegen aan afspeellijst",
  "playlistView.add-first-item": "Voeg oefeningen toe",
  "playlistView.empty-description": "Voeg oefeningen, tekst-naar-spraak instructies of spraakopnames toe om je oefenroutine op te bouwen.",
  "playlistView.empty-title": "Je afspeellijst is leeg",

  "toast.share-linked-copied": "Deel-link gekopieerd naar klembord",

  "playlistShare.title": "Afspeellijst Delen",
  "playlistShare.visibility": "Zichtbaarheid",
  "playlistShare.only-me": "Alleen ik",
  "playlistShare.with-link": "Iedereen met de link",
  "playlistShare.make-public": "Afspeellijst openbaar maken",
  "playlistShare.link": "Deel-link",
  "playlistShare.help-text": "Door een afspeellijst openbaar te maken, kunnen anderen deze als favoriet toevoegen. Wijzigingen die je aanbrengt zijn direct zichtbaar voor iedereen die de lijst bewaart.",
  "playlistShare.favorite-count": "Deze afspeellijst heeft {count} favorieten.",
  "playlistShare.private-notice": "Deze afspeellijst is momenteel privé. Alleen jij kunt hem zien.",
  "playlistShare.private-impact": "{count} gebruikers die je afspeellijst bewaard hebben, kunnen deze nu niet meer zien.",

  "voicePlan.no-lessons": "Je hebt nog geen lessen!",
  "voicePlan.no-lessons-description.a": "Je kunt een nieuwe les voor jezelf of een student toevoegen door op de plusknop te klikken",
  "voicePlan.no-lessons-description.b": "aan de rechterkant, onder het deel-icoon.",
  "voicePlan.wait-for-teacher": "Wacht tot je leraar lessen en opdrachten toevoegt!",
  "voicePlan.not-found": "Voice plan niet gevonden",
  "voicePlan.not-found-description": "Het voice plan dat je zoekt bestaat niet of is verwijderd.",
  "voicePlan.back-to-list": "Terug naar voice plans",
  // Deze componenten vormen eigenlijk één zin,
  // maar moeten apart worden vertaald
  // omdat er in de zin svelte-componenten worden gebruikt.
  // Beetje omslachtig, ik weet het.
  "lesson.explanation.a": "Je kunt",
  "lesson.explanation.b": "de titel bewerken",
  "lesson.explanation.c": "door te tikken",
  "lesson.explanation.d": "Verwijder deze les door op de",
  "lesson.explanation.e": "Of voeg een nieuwe",
  "lesson.explanation.f": "opdracht",
  "lesson.explanation.g": "toe door te tikken op de",
  "lesson.explanation.h": "Of kies een template: ",
  "lesson.select-template": "Selecteer een template",
  "lesson.global-template-label": "Globaal",
  "lesson.global": "Algemeen",
  "lesson.no-templates": "Geen templates beschikbaar",
  "lesson.wait-for-teacher": "Wacht tot je leraar opdrachten toevoegt!",
  "lesson.toast.deleted-lesson": "De les verwijderd",
  "lesson.prompt-name": "Voer een naam in voor deze les",
  "lesson.loading-exercises": "Oefeningen laden...",
  "lesson.exercises-load-error": "Oefeningen konden niet worden geladen. Andere voice plans in dit tabblad kunnen tot een retry ook vastlopen.",
  "lesson.prompt-template-name": "Voer een naam in voor deze template",
  "lesson.template-name": "Template naam",
  "lesson.ask-global": "Wil je deze template voort iedereen beschikbaar maken?",
  "lesson.edit-name": "Lesnaam bewerken",
  "lesson.remove": "Les verwijderen",
  "lesson.add": "Les toevoegen",
  "lesson.save-template": "Opslaan als template",
  "lesson.add-stemprofiel": "Stemprofiel toevoegen",
  "lesson.remove-stemprofiel": "Stemprofiel verwijderen",
  "lesson.remove-stemprofiel-confirm": "Weet je zeker dat je het stemprofiel van deze les wilt verwijderen? Dit wist alle ingevulde gegevens.",
  "assignment.toast.deleted-assignment": "De opdracht verwijderd",

  "voicePlanListItem.namePrompt": "Voer een naam in voor dit voice plan",

  "voicePlanInvitation.give-voice-plan-name": "Geef je voice plan een naam",
  "voicePlanInvitation.accept": "Accepteren",
  "voicePlanInvitation.decline": "Afwijzen",
  "voicePlanInvitation.open": "Openen",

  "newAssignmentModal.add-assignment": "Opdracht toevoegen",
  "newAssignmentModal.search-placeholder": "Typ oefeningsnummer of trefwoord om te zoeken...",
  "newAssignmentModal.description": "Omschrijving",
  "newAssignmentModal.language": "Taal",
  "newAssignmentModal.language-explanation": "Het universal voice system is in meerdere talen uitgegeven, en elke taal heeft een eigen nummering. Kies de taal die je wilt gebruiken.",
  "newAssignmentModal.not-teacher": "Je moet een leraar zijn om opdrachten te bewerken.",
  "newAssignmentModal.template-title-qustion": "Wat is de titel van deze template?",
  "newAssignmentModal.template-description-qustion": "Wat is de beschrijving van deze template?",
  "newAssignmentModal.template-title-description-required": "Titel en beschrijving zijn vereist om een template op te slaan.",

  "invitations.no-invitations": "Je hebt nog geen uitnodigingen.",
  "invitations.no-invitations-description.a": "Je kunt andere mensen uitnodigen als",
  "invitations.no-invitations-description.b": "jouw student",
  "invitations.no-invitations-description.c": "door op de plusknop te klikken",
  "invitations.no-invitations-description.d": "in de rechterbenedenhoek.",
  "invitations.invited-by": "Uitgenodigd door: {{name}}",
  "invitations.pending-title": "Openstaande uitnodigingen",
  "invitations.accepted-title": "Geaccepteerde uitnodigingen",

  "invitation.accept": "Accepteren",
  "invitation.decline": "Afwijzen",
  "invitation.invited-badge": "Uitgenodigd",

  "invite.title": "Mensen uitnodigen",
  "invite.email-placeholder": "Voer e-mailadres in",
  "invite.can-edit": "Kan bewerken?",
  "invite.send": "Verzend uitnodiging",
  "invite.pending": "In behandeling",
  "invite.accepted": "Geaccepteerd",
  "invite.remove": "Verwijderen",
  "invite.error": "Uitnodiging verzenden mislukt",
  "invite.no-invitees": "Nog niemand uitgenodigd",
  "invite.migrate-title": "Delen inschakelen",
  "invite.migrate-description": "Dit voice plan gebruikt het oude deelsysteem. Schakel het in om te zien wie toegang heeft en nieuwe mensen uit te nodigen. Bestaande gebruikers met toegang worden automatisch toegevoegd.",
  "invite.migrate-enable": "Delen inschakelen",
  "invite.migrate-success": "Delen ingeschakeld! De volgende mensen hebben toegang:",
  "invite.migrate-users-found": "Gebruikers met toegang",
  "invite.migrate-continue": "Doorgaan naar uitnodigen",

  "exercise_editor.no_permission": "Je hebt geen toestemming om oefeningen te publiceren. Neem contact op met de beheerder.",
  "exercise_editor.title": "Oefeningen Editor",
  "exercise_editor.description": "Wanneer je een oefening bewerkt, wordt deze niet direct gepubliceerd naar de app of het portaal.",
  "exercise_editor.language": "Taal",
  "exercise_editor.check_changes": "Controleren op wijzigingen",
  "exercise_editor.checking": "Controleren op wijzigingen...",
  "exercise_editor.publish_app": "Publiceren naar app",
  "exercise_editor.no_changes": "Er zijn geen openstaande wijzigingen",
  "exercise_editor.no_changes_note": "Het kan tot een minuut duren voordat wijzigingen worden gedetecteerd.",
  "exercise_editor.publish_portal": "Publiceren naar portaal",
  "exercise_editor.publish_app_first": "Eerst publiceren naar app",
  "exercise_editor.search_placeholder": "Begin met typen om een oefening te vinden",
  "exercise_editor.new": "Nieuwe oefening",
  "exercise_editor.save": "Opslaan",
  "exercise_editor.clear": "Wissen",
  "exercise_editor.autocomplete_hint": "Let op: Alleen gepubliceerde oefeningen worden automatisch aangevuld.",
  "exercise_editor.not_found": "Oefening {{id}} niet gevonden",
  "exercise_editor.previous": "Vorige",
  "exercise_editor.next": "Volgende",
  "exercise_editor.chapter": "Hoofdstuk {{chapter}}",
  "exercise_editor.chapter_more": "Meer",
  "faq.title": "VEELGESTELDE VRAGEN",
  "faq.question1": "Hoe kan ik de naam van een voice plan bewerken of verwijderen?",
  "faq.answer1": "Druk lang op de naam van het voice plan in de voiceplan-lijst om het contextmenu te openen. In dit menu kun je de naam van het voice plan bewerken of het voice plan volledig verwijderen.",
  "faq.question2": "Hoe kan ik een les bewerken en sorteren?",
  "faq.answer2": "Tik op het nummer van de opdracht, of het icoon bovenaan de opdracht om het contextmenu te openen. In dit menu kun je de opdracht bewerken, de opdracht verwijderen, of de opdracht naar een andere positie verplaatsen.",
  "faq.qas": [
    {
      "question": "Hoe annuleer ik mijn abonnement?",
      "answer": 'Je kunt je abonnement annuleren door naar je <a href="/settings">accountinstellingen</a> te gaan en op de rode annuleren knop te klikken. Je abonnement blijft actief tot de einddatum van je huidige abonnementsperiode. <br /><img src="images/faq/cancel_abo_nl.png" alt="alt_text" title="cancel subscription"/>',
    },
    {
      "question": "Hoe kan ik de naam van een voice plan bewerken of verwijderen?",
      "answer": "Druk lang op de naam van het voice plan in de voiceplan-lijst om het contextmenu te openen. In dit menu kun je de naam van het voice plan bewerken of het voice plan volledig verwijderen."
    },
    {
      "question": "Hoe kan ik een les bewerken en sorteren?",
      "answer": "Tik op het nummer van de opdracht, of het icoon bovenaan de opdracht om het contextmenu te openen. In dit menu kun je de opdracht bewerken, de opdracht verwijderen, of de opdracht naar een andere positie verplaatsen.<img src=\"/images/assignment_example.png\" alt=\"assignment example\" />"
    },
    {
      question: 'Hoe maak ik een voiceplan voor mezelf? / Hoe nodig ik een student uit?',
      answer: 'Wil je een voiceplan voor jezelf of voor je student toevoegen, klik dan op het oranje bolletje met het witte plusje erop. Je komt op een volgend scherm waar je de titel van het voiceplan kunt invullen. Is dit voiceplan voor jouw student? Vul dan het e-mailadres in van je student en klik op ‘Nodig student uit’. Wil je een voiceplan voor jezelf maken, vul dan de titel en klik daarna op ‘Creëer voor mezelf’.<img src="images/faq/hoe_maak_ik_een_voiceplan.png" alt="alt_text" title="image_tooltip">'
    },
    {
      question: 'Voiceplan hernoemen, tags geven of verwijderen',
      answer: 'Wil je een voiceplan hernoemen, een tag geven of verwijderen? Klik dan op de drie puntjes aan rechterkant van het Voice Plan<img src="images/faq/voiceplan_hernoemen.png" alt="alt_text" title="image_tooltip"><ul><li> Verwijderen: Klik op het ‘prullenbakje’ </li><li>Hernoemen: Klik op het ‘notitieblokje’ en geef het plan een nieuwe titel </li><li>Tag geven: Klik op de ‘tag’ Typ de naam van de tag in die je het wilt geven.</li><ul>'
    },
    {
      question: 'Hoe voeg ik een les toe? En hoe geef ik deze een naam?',
      answer: 'Wil je binnen een voiceplan één of meerdere lessen aanmaken, klik dan op het oranje bolletje met het witte plusje. Meteen wordt er een les aangemaakt, met als titel de datum van vandaag. Wil je deze les een specifieke naam geven? Klik dan op het notitieblokje om de titel aan te passen naar bijvoorbeeld ‘Belting’ of ‘Omvang ontwikkelen’<img src="images/faq/hoe_voeg_ik_een_les_toe.png" alt="alt_text" title="image_tooltip"><img src="images/faq/hoe_voeg_ik_een_les_toe_2.png" alt="alt_text" title="image_tooltip">'
    },
    {
      question: 'Hoe voeg ik een oefening toe? Hoe zoek ik een oefening in de database?',
      answer: 'Als je een oefening toe wilt voegen aan je lesplan, klik dan op het oranje plusje.<img src="images/faq/hoe_voeg_ik_een_oefening_toe.png" alt="alt_text" title="image_tooltip">Er komt een scherm tevoorschijn. Wil je een oefening uit het Universal Voice Portaal toevoegen? Voer dan het nummer in van de oefening, bijvoorbeeld ‘005’. De oefening komt tevoorschijn, klik erop, en druk op Wijzigingen opslaan om je oefening op te slaan.<img src="images/faq/hoe_voeg_ik_een_oefening_toe_2.png" alt="alt_text" title="image_tooltip">Wil je nog specifieke aanwijzingen of een extra beschrijving toevoegen aan de oefening? Schrijf dan in het tekstblokje een aanwijzing, bijvoorbeeld: “Let op dat je in de klassieke houding blijft staan.”, of, “Probeer elke noot met evenveel scherpte te zingen”Weet je vantevoren nog niet welke oefening wilt toevoegen? Je kunt ook de zoekfunctie gebruiken om te zoeken naar welke oefening je zou willen doen. Je kunt bijvoorbeeld zoeken op ‘kwint’, dan komen alle oefeningen met de omvang kwint tevoorschijn. Of typ liptril, dan komen alle oefeningen waar een liptril in voorkomt tevoorschijn. Kies een van deze oefeningen, en klik op Wijzigingen opslaan.<img src="images/faq/hoe_voeg_ik_een_oefening_toe_3.png" alt="alt_text" title="image_tooltip">Onthoud dat elke oefening een specifiek nummer heeft. Dat nummer correspondeert met het hoofdstuk waar het instaat. Oefening 411 komt uit hoofdstuk 4 (Speech), oefening 523 komt uit oefening 5 (Belting). Oefening 1121 komt uit hoofdstuk 11 (Gezondheid).'
    },
    {
      question: 'Ik wil een oefening aanpassen/verwijderen, hoe doe ik dat?',
      answer: 'Heb je een oefening in je lesplan staat dat je wilt aanpassen? Klik dan op de oranje titel van de oefening, bijvoorbeeld 005 (of als er geen titel staat, het oranje rondje). Door op de pijltjes te klikken, kun je de oefening hoger of lager in het lesplan zetten. Wil je de oefening verwijderen? Klik dan op het prullenbakje. Wil je de oefening aanpassen? Klik dan op het notitieblokje.<img src="images/faq/oefening_aanpassen.png" alt="alt_text" title="image_tooltip">'
    },

    {
      question: 'Ik wil een karaoketrack van youtube of Spotify toevoegen, hoe doe ik dat?',
      answer: 'Klik in een Voiceplan op het oranje plusje, in plaats van een oefening uit de database te zoeken, klik je nu in het tekstvakje op ‘Invoegen’. Klik daarna op Link. Voeg de URL naar de betreffende karaoketrack toe en klik op ‘Wijzigingen opslaan’<img src="images/faq/ik_wil_een_karaoketrack.png" alt="alt_text" title="image_tooltip">'
    },
    {
      question: 'Mijn docent heeft mij uitgenodigd, waar vind ik de uitnodiging?',
      answer: 'Rechtsboven in de app zie je een menu. Daar zie je het kopje ‘Uitnodigingen’. Als je daar op klikt zie je alle lesplannen waar nog een uitnodiging opstaat. Staat hier geen uitnodiging? Dan heb je of het Voiceplan al in je lijst staan, of vraag dan opnieuw of de docent je wil uitnodigingen<img src="images/faq/mijn_docent_heeft_mij.png" alt="alt_text" title="image_tooltip">'
    },
    {
      id: 'share-voice-plan',
      question: 'Hoe kan een docent een voiceplan delen met een student via het nieuwe systeem?',
      answer: 'De docent opent het voiceplan in de app, klikt bovenaan op de oranje knop \'Mensen uitnodigen\' (het icoontje met het persoon-plus symbool), voert het e-mailadres van de student in, en klikt op \'Uitnodiging verzenden\'. De student ziet de uitnodiging vervolgens in zijn of haar eigen app onder het menu <b>Uitnodigingen</b> (rechtsboven in de hoek), waar deze geaccepteerd kan worden.'
    }
  ],
  "createVoicePlan.title": "Maak Voice Plan",
  "createVoicePlan.send-this-invite-line": "Stuur deze uitnodigingslink naar je student:",
  "createVoicePlan.voice-plan-name": "Voice Plan Naam",
  "createVoicePlan.name-for-student": "Een naam die je wilt gebruiken voor deze student",
  "createVoicePlan.invite": "Uitnodigen",
  "createVoicePlan.create-for-myself": "Creëer voor mezelf",
  "createVoicePlan.create-for-student-or-yourself": "Maak een voiceplan voor jezelf of voor een student!",
  "createVoicePlan.name-for-student-or-self": "Een naam die je wilt gebruiken voor de student of jezelf",
  "createVoicePlan.email-to-add": "E-mail die je wilt toevoegen",
  "createVoicePlan.add": "Toevoegen",
  "createVoicePlan.students": "Studenten",
  "createVoicePlan.name-required": "Voer een naam in voor dit voice plan",
  "createVoicePlan.subtitle": "Maak een nieuw voice plan voor jezelf of een student",
  "createVoicePlan.basic-info": "Basisgegevens",
  "createVoicePlan.name": "Voice Plan Naam",
  "createVoicePlan.name-placeholder": "bijv. Belting oefeningen - Jan",
  "createVoicePlan.invite-people": "Mensen uitnodigen",
  "createVoicePlan.invite-description": "Je kunt optioneel mensen uitnodigen voor dit voice plan. Sla deze stap over als je later wilt uitnodigen.",
  "createVoicePlan.role": "Rol",
  "createVoicePlan.role-both": "Leraar & Student",
  "createVoicePlan.role-teacher": "Leraar",
  "createVoicePlan.role-student": "Student",
  "createVoicePlan.tags": "Tags",
  "createVoicePlan.add-tags": "Voeg tags toe om je voice plans te organiseren",
  "createVoicePlan.tag-placeholder": "Typ een tag en druk op Enter",
  "createVoicePlan.quick-categories": "Snel toevoegen van favoriete tags",
  "createVoicePlan.review": "Controleren",
  "createVoicePlan.create": "Maak Voice Plan",

  //"Student heeft nog geen account."
  "createVoicePlan.student-has-no-account": "Student heeft nog geen account",
  //"Student heeft een account"    
  "createVoicePlan.student-has-an-account": "Student heeft een account.",
  // Nodig studenten uit
  "createVoicePlan.invite-students": "Nodig studenten uit",
  // Nodig student uit
  "createVoicePlan.invite-student": "Nodig student uit",
  // Creëer voor mezelf

  "createVoicePlan.description.a": "Na het benoemen van dit voiceplan kun je de e-mails van de studenten die je wilt uitnodigen toevoegen.",
  "createVoicePlan.description.b": "Als de student",
  "createVoicePlan.description.c": "een account heeft",
  "createVoicePlan.description.d": ", zullen zij toegevoegd worden aan het voiceplan.",
  "createVoicePlan.description.e": "Als zij",
  "createVoicePlan.description.f": "nog geen account hebben",
  "createVoicePlan.description.g": ", zullen zij de uitnodiging zien zodra zij inloggen.",
  "createVoicePlan.description.h": "Als je een voiceplan voor",
  "createVoicePlan.description.i": "jezelf",
  "createVoicePlan.description.j": "wilt maken, geef het dan gewoon een naam en klik op 'creëer voor mezelf.'",

  "invitation.title": "Je bent uitgenodigd om deel te nemen aan een voice plan",
  "invitation.description.a": "Geef het een naam (de naam van je",
  "invitation.description.b": "leraar",
  "invitation.description.c": "misschien?)",
  "invitation.description.d": "selecteer welke rol je wilt",
  "invitation.description.e": "en klik op accepteren!",
  "invitation.a-name-for-this-voice-plan": "Een naam die je wilt gebruiken voor dit voice plan",

  "invitation.student": "Student",
  "invitation.teacher": "Leraar",
  "invite.banner.title": "Nieuwe manier van voiceplans delen",
  "invite.banner.description": "We hebben een nieuwe, veilige manier geïntroduceerd om voiceplans direct te delen. Je bekijkt momenteel een alleen-lezen weergave van dit voice plan.",
  "invite.banner.student-notice": "Om opnames te maken, oefeningen te doen, of dit voice plan volledig te gebruiken, vraag je docent om je uit te nodigen via de nieuwe e-mail uitnodigingsfunctie in de app.",
  "invite.banner.teacher-notice": "Ben je de docent/maker van dit plan? Open dit voice plan in de app, klik bovenaan op de oranje knop 'Mensen uitnodigen', vul het e-mailadres van de student in en klik op 'Uitnodiging verzenden'.",
  "invite.banner.faq-link": "Bekijk de instructies in de FAQ",

  "inlineTagsEditor.tag-color-prompt": "Tag kleur",
  "inlineTagsEditor.tag-removed": "Tag verwijderd",
  "voicePlanList.filter-by-tags": "Zoek op tags",
  "voicePlanList.search-by-name": "Zoek op naam",
  "voicePlanList.tags-active": "tags actief",
  "voicePlanList.other": "Overig",

  // login
  "login.name": "naam",
  "login.login": "INLOGGEN",
  "login.email": "E-mailadres",
  "login.userid": "User ID",
  "login.password": "Wachtwoord",
  "login.forgot": "Wachtwoord vergeten?",
  "login.no-account": "NOG GEEN ACCOUNT?",
  "login.the-place": "dé plek om jouw stem online te trainen",
  "login.more-than": "meer dan 1400 oefeningen",
  "login.try-free": "PROBEER NU 2 WEKEN GRATIS",
  "login.make-account": "MAAK EEN ACCOUNT",
  "login.uvi-title": "Het Universal Voice Portaal",
  "login.uvi-text": "Het Universal Voice Portaal is dé plek waar je jouw stem online kunt trainen. Wat houdt het in? Alle oefeningen (meer dan 1400) van de Universal Voice Guide staan gecategoriseerd gespecificeerd in verschillende stijlen. Een ideale studieomgeving om snel en efficiënt te werken aan je Speech, Belting, Whisper, Classical of Effecten. Bij elke oefening is er een ingezongen voorbeeld van een man en vrouw, met daarbij instrumentale tracks op verschillende toonhoogtes waardoor elke oefening voor iedere stem geschikt is. Voor elk doel, bijvoorbeeld luider zingen, zijn er ook meerdere oefeningen, oplopend in moeilijkheidsgraad. Geschikt dus voor zowel de beginnende als de professionele zanger. Is je doel nou om hoger te leren zingen, lager, luider, met meer vibrato, of donkerte, voor elk vocaal doel kun je bij het Universal Voice Portaal terecht.",
  "login.register-page": "14864",
  "login.login-with-google": "Inloggen met Google",
  "login.login-with-wordpress": "Inloggen met Wordpress",
  "login.login-with-password": "Inloggen",
  "login.login-with-email": "Inloggen via e-mail",
  "login.email-login-link": "E-mail een login link",
  "login.email-required": "Voer je e-mailadres in",
  "login.sending-email-link": "Login link verzenden...",
  "login.email-link-sent": "Een login link is verzonden naar {{email}}. Controleer je e-mail en klik op de link om in te loggen.",
  "login.wrong-password": "Deze combinatie van e-mail en wachtwoord is niet geldig",
  "login.start-migration": "Start account migratie",
  "login.unknown-error": "Er is een onbekende fout opgetreden, probeer het later opnieuw. Of neem contact op met de ondersteuning.",
  "login.migration.1": `<p>We zijn altijd bezig om onze website te verbeteren en om u de beste service te bieden. Daarom zijn we overgestapt naar een nieuwe aanbieder voor de verificatie van uw account. Om deze reden moet u uw wachtwoord opnieuw instellen.</p>`,
  "login.migration.2": "Meer info",
  "login.migration.3": `<p>Het is heel eenvoudig om uw wachtwoord te resetten. Volg gewoon deze stappen:</p>
    <ol>
        <li>Klik op de link hieronder om naar de pagina voor het opnieuw instellen van uw wachtwoord te gaan.</li>
        <li>Voer uw e-mailadres in en klik op "Verstuur".</li>
        <li>U ontvangt een e-mail met een link om uw nieuwe wachtwoord te kiezen.</li>
        <li>Klik op de link en voer uw nieuwe wachtwoord in.</li>
        <li>Bevestig uw nieuwe wachtwoord en klik op "Opslaan".</li>
        <li>U kunt nu inloggen met uw nieuwe wachtwoord.</li>
    </ol>
    <p>We hopen dat u tevreden bent met deze verandering en dat u blijft genieten van onze website. Als u vragen of problemen heeft, neem dan gerust contact met ons op.</p>
    <p>Bedankt voor uw begrip en uw vertrouwen in ons.</p>`,
  "login.email-sent": "Als er een account bestaat met het opgegeven e-mailadres, is er een e-mail verzonden met instructies om uw wachtwoord opnieuw in te stellen.",
  "login.reset-password": "Wachtwoord opnieuw instellen",
  "login.need-to-migrate": "Uw account moet gemigreerd worden om verder te gaan, om te starten klikt u op de knop hieronder om uw wachtwoord te resetten. Het hele proces duurt slechts een kort ogenblik.",
  "login.you-will-be-migrating": "U gaat {{email}} migreren",
  "login.after-payment": "Je betaling is in behandeling, log in om verder te gaan.  ",
  "login.error": "Inloggen mislukt. Probeer het opnieuw.",
  "login.title": "Log in om verder te gaan",
  "login.signing-in": "Bezig met inloggen...",
  "login.sign-in": "Inloggen",
  "login.login-to-continue": "Log in om verder te gaan.",
  "login.street": "Straat",
  "login.postcode": "Postcode",
  "login.city": "Stad",

  "settings.profile": "Profiel",
  "settings.interface": "Interface",
  "settings.subscription": "Abonnement",
  "settings.billingRenewsOn": "Uw abonnement wordt verlengd op {{date}} (volgende incasso).",
  "settings.billingEndsWithoutRenewal": "U behoudt toegang tot {{date}}. Dit abonnement wordt niet automatisch verlengd.",
  "settings.billingAccessUntil": "Uw abonnementstoegang is geldig tot {{date}}.",
  "settings.billingIndefiniteAccess": "Uw abonnement heeft geen geplande einddatum of automatische verlenging.",
  "settings.subscriptionInfo": "Uw abonnement is {{subscriptionState}}",
  "settings.payments": "Betalingen",
  "settings.download": "downloaden",
  "settings.subscriptionStateUnknown": "Uw abonnementsstatus is onbekend",
  "settings.cancelSubscription": "Abonnement annuleren",
  "settings.cancelSubscriptionShort": "Annuleren",
  "settings.save": "Opslaan",
  "settings.inputWarning": "Niet toegestaan: {{input}}",
  "settings.lesson_templates": "Les templates",
  "settings.global_templates": "Algemene templates",
  "settings.subscribeTeaser": "Neem een abonnement om toegang te krijgen tot Voice Plans!",
  "settings.subscribeCta": "Abonneer nu!",

  // UI Settings
  "ui.experimentalNavigation": "Experimentele Navigatie",
  "ui.currentlyUsingExperimental": "Je gebruikt momenteel onze experimentele navigatie met verbeterde mobiele ondersteuning en modern ontwerp.",
  "ui.enableExperimental": "Schakel onze experimentele navigatie in voor verbeterde mobiele ondersteuning en modern UI ontwerp.",
  "ui.enabled": "Ingeschakeld",
  "ui.disabled": "Uitgeschakeld",
  "ui.reloadNote": "De pagina zal automatisch opnieuw laden na het wijzigen van navigatie-instellingen om de nieuwe interface toe te passen.",

  // New UI Teaser
  "teaser.title": "🚀 Probeer Onze Nieuwe UI!",
  "teaser.subtitle": "Ervaar onze experimentele navigatie-indeling met verbeterde bruikbaarheid en modern ontwerp",
  "teaser.description": "We hebben gewerkt aan een compleet nieuwe navigatie-ervaring die het makkelijker maakt om:",
  "teaser.feature1": "✨ Te navigeren tussen verschillende secties",
  "teaser.feature2": "📱 De app op mobiele apparaten te gebruiken",
  "teaser.feature3": "🎯 Sneller te vinden wat je zoekt",
  "teaser.feature4": "🔄 Te schakelen tussen voice plans en tools",
  "teaser.enableButton": "Nieuwe Navigatie Inschakelen",
  "teaser.note": "Dit schakelt de experimentele navigatie in voor je account. Je kunt het later altijd uitschakelen in je instellingen.",
  "teaser.success": "Succes! Nieuwe navigatie succesvol ingeschakeld.",
  "teaser.reloadMessage": "De pagina zal automatisch opnieuw laden over een paar seconden om de nieuwe interface te tonen...",
  "teaser.error": "Fout:",
  "teaser.tryAgain": "Probeer Opnieuw",

  // Voice Plan List Banner
  "banner.tryNewNavigation": "Probeer onze nieuwe experimentele navigatie!",
  "banner.improvedMobile": "Ervaar verbeterde mobiele navigatie en modern UI ontwerp. Kan ook geactiveerd via instellingen ⚙️.",
  "banner.tryNow": "Probeer Nu",

  // Purchase Flow
  "purchase.title": "Digitale Boeken Toegang",
  "purchase.subtitle": "Ontgrendel onze complete bibliotheek van digitale boeken",
  "purchase.feature1": "Toegang tot alle digitale boeken",
  "purchase.feature2": "Hoogwaardige PDF leeservaring",
  "purchase.feature3": "Werkt op alle apparaten",
  "purchase.feature4": "Nieuwe boeken worden regelmatig toegevoegd",
  "purchase.oneTime": "Eenmalig",
  "purchase.getAccess": "Krijg Nu Toegang",
  "purchase.alreadyHaveAccess": "Heb je al toegang? Neem contact op met support als je problemen hebt met het openen van je boeken.",

  "errors.userNotFound": "De gekozen gebruiker is niet gevonden.",
  "errors.timeout": "De aanvraag is verlopen. Probeer het later opnieuw.",
  "errors.sign_in_required": "Log in om verder te gaan.",

  "errors.awaitingPayment": "U kunt inloggen wanneer we uw betaling hebben ontvangen",
  "payments.subscriptionName": " Universeel Voice Abonnement",
  "payments.next": "volgende",
  "payments.previous": "vorige",
  "payments.missing-a-payment": "Een betaling gemist?",
  "payments.retrieve-payments": "Betalingen ophalen",
  "payments.no-payments": "Geen betalingen gevonden",
  "payments.payments": "Betalingen",
  "payments.period": "Periode",
  "payments.date": "Datum",
  "payments.error": "Er is een fout opgetreden, probeer het later opnieuw of neem contact op met de ondersteuning.",
  "payment.noPayments": "Geen betalingen gevonden",
  "payment.pending.title": "Betaling in behandeling",
  "payment.pending.message": "Uw abonnementsbetaling wordt verwerkt. Dit kan enkele seconden tot meerdere dagen duren, afhankelijk van uw betaalmethode.",
  "payment.pending.waiting": "Wachten op betalingsbevestiging...",
  "payments.loading": "Betalingen laden...",
  "payments.generatingInvoices": "Genereren van {{count}} factuurnummers...",
  "payments.generatingInvoice": "Genereren van factuur {{current}} van {{total}}...",
  "payments.syncing": "Betalingen synchroniseren...",

  "subscription.expired": "Verlopen",
  "subscription.deleted": "Verwijderd",
  "subscription.active": "Actief",
  "subscription.mollie.message.expired": "Uw abonnement is verlopen, ga naar uw account om uw abonnement te verlengen.",
  "subscription.mollie.message.active": "Geldig tot {{endDate}}",
  "subscription.mollie.canceled": "Geannuleerd",
  "subscription.mollie.name": "Premium",

  "subscription.school.message.expired": "Uw school abonnement is verlopen. Als dit niet klopt, neem dan contact op met de vertegenwoordiger van uw school.",
  "subscription.school.message.active": "Geldig tot {{endDate}}",
  "subscription.school.name": "Educatief",

  "subscription.special.message.expired": "Uw speciale abonnement is niet meer geldig, als dit niet klopt, neem dan contact op met de klantenservice.",
  "subscription.special.message.active": "Geldig voor onbepaalde tijd.",
  "subscription.special.message.active.until": "Geldig tot {{endDate}}.",

  "subscription.special.name": "Speciaal",
  "subscription.organization.name": "Organisatie Licentie - {{orgName}}",
  "subscription.organization.message.active": "Actief via {{orgName}}",
  "subscription.organization.message.revoked": "Uw licentie is ingetrokken door uw organisatie.",
  "subscription.noSubscription": "U heeft geen abonnementen",

  "migration.title": "Uw account ophalen",
  "migration.check-payments": "Betalingen controleren",
  "migration.check-subscriptions": "Abonnementen controleren",
  "migration.check-ready": "Account ophalen",
  "migration.no-payments": "Geen betalingen gevonden, het kan een paar minuten duren om uw betaling te verwerken. Als u al heeft betaald en denkt dat dit een vergissing is, neem dan contact op met de ondersteuning.",
  "migration.no-subscriptions": "Geen abonnementen gevonden, het kan een paar minuten duren om uw abonnement te verwerken. Als u denkt dat dit een vergissing is, neem dan contact op met de ondersteuning.",
  "migration.explanation": "We moeten eenmalig uw account migreren naar het nieuwe betalingsplatform. Geen zorgen, u hoeft niets te doen, we vragen alleen om een klein ogenblik geduld.",
  "migration.takesLong": "Het duurt wat langer dan normaal, maar we zijn er bijna!",
  "checkout.help.email": "Uw emailadres is ingevuld omdat u bent ingelogd.",
  "checkout.content.1": `Om de portaal uit te proberen krijg je de eerste <b class="has-text-primary">twee weken</b> van ons
  cadeau. Je betaalt hiervoor vandaag €0.02. Je kunt binnen twee weken
  opzeggen of vervolgens voor het gekozen termijn bedrag gebruik
  blijven maken van ons portaal. Het abonnementsgeld wordt pas na twee
  weken afgeschreven.`,
  "checkout.content.1.discount": `Om de portaal uit te proberen krijg je de eerste <b class="has-text-primary">drie maanden</b> van ons
  cadeau. Je betaalt hiervoor vandaag €0.02. Je kunt binnen drie maanden
  opzeggen of vervolgens voor het gekozen termijn bedrag gebruik
  blijven maken van ons portaal. Het abonnementsgeld wordt pas na drie maanden
  afgeschreven.`,
  "checkout.content.1.dynamic": `Om de portaal uit te proberen krijg je de eerste <b class="has-text-primary">{{period}}</b> van ons
  cadeau. Je betaalt hiervoor vandaag €0.02. Je kunt binnen {{period}}
  opzeggen of vervolgens voor het gekozen termijn bedrag gebruik
  blijven maken van ons portaal. Het abonnementsgeld wordt pas na {{period}}
  afgeschreven.`,
  "checkout.content.2": "Sluit nu een abonnement af zodat je altijd gebruik kunt maken van het Universal Voice Trainingsportaal!",
  "checkout.free": "Gratis",
  "checkout.monthly": "Per maand",
  "checkout.yearly": "Per jaar",
  "checkout.quarterly": "Per 3 maanden",
  "checkout.name": "Naam",
  "checkout.email": "E-mail",
  "checkout.subscription": "Subcription",
  "checkout.docent-code": "Docentcode (optioneel)",
  "checkout.teacher-code-tooltip": "Als je les hebt van een Universal Voice Teacher, heeft die docent je wellicht een speciale code gegeven. Deze kun je hier invullen. Mocht je die niet hebben ontvangen, geen probleem — het is niet nodig voor het verdere proces",
  "checkout.referred-by-teacher": "Bent u doorverwezen door een van onze docenten?",
  "checkout.teacher-code-explanation": "Als een referentiecode van uw docent heeft gekregen, vul deze dan hier in.",
  "checkout.discount-code-placeholder": "KORTINGSCODE",
  "checkout.discount-code-validating": "Kortingscode valideren...",
  "checkout.discount-code-invalid": "Ongeldige kortingscode",
  "checkout.trial-period.one-week": "één week",
  "checkout.trial-period.two-weeks": "twee weken",
  "checkout.trial-period.weeks": "{{count}} weken",
  "checkout.trial-period.one-month": "één maand",
  "checkout.trial-period.two-months": "twee maanden",
  "checkout.trial-period.three-months": "drie maanden",
  "checkout.trial-period.six-months": "zes maanden",
  "checkout.trial-period.months": "{{count}} maanden",
  "checkout.trial-period.days": "{{count}} dagen",
  "checkout.discount.explanation.three-months": "Deze kortingscode verlengt uw proefperiode tot drie maanden.",
  "checkout.to-payment": "Naar betaling",
  "checkout.without-subscription": "Account aanmaken zonder abonnement",
  "checkout.password": "Password",

  "cookie.showPreferences": "Cookie voorkeuren tonen",

  "errors.auth/wrong-password": "Onjuist wachtwoord. Probeer het opnieuw. Tip: als je bent aangemeld met een passkey, heb je mogelijk nog geen wachtwoord ingesteld. Log in met je passkey of gebruik 'Wachtwoord vergeten' om een wachtwoord in te stellen.",
  "errors.auth/invalid-credential": "Ongeldig e-mailadres of wachtwoord. Probeer het opnieuw. Tip: als je bent aangemeld met een passkey, heb je mogelijk nog geen wachtwoord ingesteld. Log in met je passkey of gebruik 'Wachtwoord vergeten' om een wachtwoord in te stellen.",
  "errors.auth/quota-exceeded": "U heeft uw limiet voor inlogpogingen bereikt. Probeer het later opnieuw.",
  "errors.auth/timeout": "Uw loginsessie is verlopen. Probeer het opnieuw.",
  "errors.auth/too-many-requests": "Te veel inlogpogingen. Probeer het over een paar minuten opnieuw.",
  "errors.auth/unverified-email": "Verifieer uw e-mailadres om in te loggen.",
  "errors.auth/user-cancelled": "Het inlogproces is geannuleerd.",
  "errors.auth/user-not-found": "Geen account gevonden met dat e-mailadres.",
  "errors.auth/user-disabled": "Uw account is geblokkeerd. Neem contact op met de support.",
  "errors.auth/unknown": "Er is een onbekende fout opgetreden ({{code}}: {{message}}). Probeer het later opnieuw.",
  "errors.auth/missing-password": "Voer een wachtwoord in om in te loggen.",
  "errors.auth/missing-email": "Voer een e-mailadres in om in te loggen.",
  "checkout.discount-code": "De volgende kortingscode wordt toegepast: {{code}}. De korting zal na het betalen van uw abonnement beginnen.",
  "checkout.account-type-title": "Kies uw account type",
  "checkout.payment-complete-sign-in": "Betaling voltooid! Log in om verder te gaan.",
  "checkout.waiting-for-payment": "Wachten op betaling",
  "checkout.payment-processing": "Uw betaling wordt verwerkt. Dit kan even duren.",
  "checkout.checking-subscription": "Abonnementsstatus controleren...",
  "checkout.payment-timeout": "Betalingsbevestiging duurt langer dan verwacht. U kunt deze pagina sluiten en later uw account controleren.",
  "checkout.retry-check": "Controleren openstaande betaling",
  "checkout.processing": "Bezig met verwerken...",
  "checkout.do-not-refresh": "Ververs of sluit deze pagina niet terwijl de betaling wordt verwerkt.",
  "checkout.payment-canceled-title": "Betaling geannuleerd",
  "checkout.payment-canceled-desc": "Je hebt de betaling geannuleerd. Er is niets in rekening gebracht.",
  "checkout.payment-failed-title": "Betaling mislukt",
  "checkout.payment-failed-desc": "De betaling is helaas niet gelukt. Probeer het opnieuw of kies een andere betaalmethode.",
  "checkout.payment-expired-title": "Betalingssessie verlopen",
  "checkout.payment-expired-desc": "De tijd om de betaling af te ronden is verlopen. Probeer het opnieuw.",
  "checkout.try-again": "Opnieuw proberen",
  "checkout.back-to-checkout": "Terug naar abonnement kiezen",
  "checkout.banner-canceled": "Je vorige betaling is geannuleerd. Kies een abonnement om het opnieuw te proberen.",
  "checkout.banner-failed": "Je vorige betaling is helaas niet gelukt. Probeer het opnieuw.",
  "checkout.banner-expired": "Je vorige betalingssessie is verlopen. Probeer het opnieuw.",

  "registration.title": "Account maken",
  "registration.subtitle": "Haal het maximale uit je stem",
  "registration.field.name": "NAAM",
  "registration.field.email": "E-MAIL",
  "registration.field.password": "WACHTWOORD",
  "registration.field.docent-code": "DOCENT CODE",
  "registration.button.signup": "AANMELDEN",
  "registration.login-link.text": "Al lid?",
  "registration.login-link.action": "Log hier in",
  "checkout.free-account-title": "Gratis Account",
  "checkout.paid-account-title": "Betaald Account",
  "checkout.free-description": "Alleen account, toegang tot digitale boeken (mogelijk in-app aankoop vereist)",
  "checkout.paid-benefit-1": "Persoonlijke Voice Plans",
  "checkout.paid-benefit-2": "Toegang tot alle oefeningen",
  "checkout.paid-benefit-3": "Toegang tot het portaal",
  "checkout.create-free-account": "Gratis account aanmaken",
  "checkout.choose-subscription": "Kies abonnement",
  "checkout.can-upgrade-later": "U kunt later altijd upgraden naar een betaald account",
  "checkout.free-account-selected": "Gratis account geselecteerd",
  "checkout.free-account-description": "U maakt een gratis account aan zonder abonnement. U kunt later altijd upgraden.",
  "checkout.payment-acknowledgment": "Ik begrijp en ga akkoord dat na de gratis proefperiode automatisch het gekozen abonnementstarief wordt afgeschreven",
  "checkout.payment-acknowledgment-help": "Door dit vakje aan te vinken bevestigt u dat u de voorwaarden begrijpt en akkoord gaat dat wij na afloop van de proefperiode automatisch de abonnementskosten zullen incasseren volgens het door u gekozen tarief.",
  "checkout.payment-acknowledgment-required": "U moet akkoord gaan met de automatische facturering na de proefperiode",
  "checkout.back-to-options": "Terug naar opties",
  "checkout.subscription-required-message": "U heeft een abonnement nodig voor deze functie",
  "checkout.subscription-required": "Selecteer een abonnement",
  "checkout.choose-subscription-plan": "Kies uw abonnement",
  "checkout.click-to-subscribe": "Klik om te abonneren",

  "audioplayer.playback-rate": "Vul afspeelsnelheid in. Een getal tussen 0.1 en 4.0",
  "audioplayer.audio-player": "Audiospeler",
  "audioplayer.seek": "Zoeken",
  "audioplayer.pause": "Pauzeren",
  "audioplayer.play": "Afspelen",
  "audioplayer.replay": "Opnieuw afspelen",
  "audioplayer.repeat": "Herhalen",
  "audioplayer.transpose-down": "Lager transponeren",
  "audioplayer.transpose-up": "Hoger transponeren",
  "audioplayer.mute": "Dempen",
  "audioplayer.unmute": "Geluid aanzetten",
  "audioplayer.volume": "Volume",

  "lessonTemplateListItem.namePrompt": "Voer een naam in voor deze template",
  "lessonTemplateListItem.confirm-remove": "Weet je zeker dat je deze template wilt verwijderen?",

  "login.needs-password-reset": "Uw wachtwoord moet opnieuw worden ingesteld, controleer uw e-mail voor een link om uw wachtwoord opnieuw in te stellen.",

  // PDF Viewer Gesture Hints
  "pdf.gesture.tap-left": "Tik om terug te gaan",
  "pdf.gesture.tap-right": "Tik om vooruit te gaan",
  "pdf.gesture.tap-center": "Tik om werkbalk te tonen",

  "verifyEmail.title": "Verifieer je e-mailadres",
  "verifyEmail.subtitle": "Er is een verificatie-e-mail verzonden naar <strong>{{email}}</strong>. Klik op de link in de e-mail om door te gaan.",
  "verifyEmail.checkSpam": "Als je de e-mail niet ziet, controleer dan je spammap.",
  "verifyEmail.resendButton": "Verificatie-e-mail opnieuw verzenden",
  "verifyEmail.resendSuccess": "Verificatie-e-mail verzonden!",
  "verifyEmail.resendError": "Fout bij het verzenden van de verificatie-e-mail. Probeer het later opnieuw.",
  "verifyEmail.processing": "Je betaling wordt voorbereid...",

  // Book Selector
  "books.title": "Digitale Boeken",
  "books.subtitle": "Kies een boek om te lezen",
  "books.owned": "In bezit",
  "books.purchasePending": "Aankoop in behandeling",
  "books.pendingMessage": "Je aankoop wordt verwerkt. Even geduld.",
  "books.pendingDetails": "Je betaling is momenteel in behandeling. Afhankelijk van de betaalmethode kan dit enkele dagen duren. Als je zeker weet dat je de betaling niet hebt voltooid, kun je opnieuw proberen te kopen.",
  "books.purchase": "Kopen - €{{price}}",
  "books.tapForPayment": "Tik voor betaalopties",
  "books.processing": "Verwerken...",
  "books.close": "Sluiten",
  "books.one-time": "eenmalig",
  "books.get-access": "Krijg nu toegang",
  "books.access-description": "Ontgrendel onze complete bibliotheek van digitale boeken",
  "books.digital-books": "Digitale Boeken",
  "books.all-singing-exercises": "Alle zangoefeningen",
  "books.pdf-music-sheets": "PDF-muziekbladen",
  "books.audio-files": "Audiobestanden met oefeningen",
  "books.video-exercises": "Video-oefeningen",
  "books.practice-tools": "Oefentools",
  "books.purchase-error": "Er is een fout opgetreden tijdens de aankoop. Probeer het opnieuw.",
  "books.buy-for": "Koop voor €{{price}}",
  "books.confirm-purchase": "Bevestig aankoop",

  "errors.user_exists": "Er is al een account gevonden met dit e-mailadres.",

  // PDF Viewer Tutorial
  "pdf.tutorial.welcome.title": "Welkom bij de Reader",
  "pdf.tutorial.welcome.content": "Laten we een snelle rondleiding nemen.",
  "pdf.tutorial.zones.title": "Navigatiezones",
  "pdf.tutorial.zones.content": "Tik links om terug te gaan, rechts om verder te gaan, of in het midden voor het menu.",
  "pdf.tutorial.toc.title": "Inhoudsopgave",
  "pdf.tutorial.toc.content": "Tik hier om hoofdstukken te zien en naar specifieke secties te springen.",
  "pdf.tutorial.search.title": "Zoeken",
  "pdf.tutorial.search.content": "Zoek specifieke tekst in het document.",
  "pdf.tutorial.offline.title": "Offline Toegang",
  "pdf.tutorial.offline.content": "Download het document voor sneller laden en offline lezen.",
  "pdf.tutorial.view.title": "Weergaveopties",
  "pdf.tutorial.view.content": "Schakel tussen enkele pagina en dubbele pagina weergave.",
  "pdf.tutorial.visual.title": "Visuele Bediening",
  "pdf.tutorial.visual.content": "Zoom in/uit of schakel tussen scrollen en pagina omslaan.",
  "pdf.tutorial.zone.previous": "Vorige",
  "pdf.tutorial.zone.menu": "Menu / Zoom",
  "pdf.tutorial.zone.next": "Volgende",
  "pdf.tutorial.action.skip": "Overslaan",
  "pdf.tutorial.action.prev": "Vorige",
  "pdf.tutorial.action.next": "Volgende",
  "pdf.tutorial.action.finish": "Klaar",
  "pdf.tutorial.dont_show": "Niet meer tonen",

  // PDF Cache Controls
  "pdf.cache.download_pdf": "PDF Downloaden",
  "pdf.cache.benefit_text": "Downloaden zorgt ervoor dat pagina's direct sneller laden.",
  "pdf.cache.updating": "Bijwerken...",
  "pdf.cache.downloaded_percentage": "% Gedownload",
  "pdf.cache.pages": "pagina's",
  "pdf.cache.ready_offline": "Klaar voor offline gebruik",
  "pdf.cache.download_full": "Volledige PDF Downloaden",
  "pdf.cache.download_tooltip": "Download voor sneller laden",
  "pdf.cache.manage_downloads": "Downloads Beheren",
  "pdf.cache.remove_download": "Download Verwijderen",
  "pdf.toolbar.back": "Terug",
  "pdf.toolbar.by": "door",
  "pdf.toolbar.zoom_out": "Uitzoomen",
  "pdf.toolbar.zoom_reset": "Zoom resetten",
  "pdf.toolbar.zoom_in": "Inzoomen",
  "pdf.toolbar.downloaded": "Gedownload",
  "pdf.toolbar.download": "Downloaden",
  "pdf.toolbar.search": "Zoeken",
  "pdf.cache.storage_used": "Totaal Opslaggebruik:",
  "pdf.cache.clear_all": "Alles Wissen",
  "pdf.cache.downloading_pages": "Pagina's downloaden...",
  "pdf.cache.processing": "Verwerken...",
  "pdf.cache.error_info_unavailable": "Kan niet downloaden: PDF-informatie niet beschikbaar",
  "pdf.cache.confirm_download": "Alle {{total}} pagina's downloaden? Dit zorgt voor soepel lezen en offline toegang.",
  "pdf.cache.success_download": "Succesvol {{total}} pagina's gedownload!",
  "pdf.cache.error_download": "Download mislukt. Probeer het opnieuw.",
  "pdf.cache.confirm_remove": "Download voor deze PDF verwijderen?",
  "pdf.cache.error_clear": "Kan cache niet wissen. Probeer het opnieuw.",
  "pdf.cache.confirm_clear_all": "ALLE downloads verwijderen? Dit verwijdert alle gedownloade PDF's van dit apparaat.",
  "pdf.cache.already_downloaded": "Alle pagina's zijn al gedownload.",
  "pdf.cache.storage_full": "Dit apparaat of Safari heeft niet genoeg ruimte voor de rest van het boek. Verwijder oude downloads of maak opslagruimte vrij op je iPad.",
  "pdf.cache.partial_download": "{{saved}} van {{total}} pagina's opgeslagen.",
  "pdf.cache.confirm_download_space": "Ongeveer {{needed}} nodig, {{remaining}} beschikbaar.",

  // Fast PDF Viewer
  "pdf.loading_config": "Documentconfiguratie laden...",
  "pdf.close": "Sluiten",
  "pdf.debug.mode": "Debug Modus",
  "pdf.debug.info": "Debug Info",
  "pdf.debug.status": "Status",
  "pdf.debug.scrolling": "Scrollen",
  "pdf.debug.current_page": "Huidige Pagina",
  "pdf.debug.scale": "Schaal",
  "pdf.debug.download_queue": "Download Wachtrij ({{active}} actief, {{pending}} wachtend)",
  "pdf.debug.render_queue": "Render Wachtrij (Prioriteitsvolgorde)",
  "pdf.chapters.title": "Hoofdstukken",
  "pdf.chapters.none": "Geen hoofdstukken beschikbaar",
  "pdf.controls.zoom_out": "Uitzoomen",
  "pdf.controls.zoom_in": "Inzoomen",
  "pdf.controls.continuous": "Continu Scrollen Modus",
  "pdf.controls.scroll": "Scrollen",
  "pdf.controls.paginated": "Gepagineerde Modus",
  "pdf.controls.page_flip": "Pagina Omslaan",
  "pdf.controls.lock_interface": "Interface Vergrendelen voor Prestaties",
  "pdf.controls.unlock_interface": "Interface Ontgrendelen",
  "pdf.loading.page": "Pagina {{page}} laden...",
  "pdf.loading.waiting": "Pagina {{page}} - Wachten op netwerk... ",
  "pdf.loading.downloading": "Pagina {{page}} - Downloaden... {{percent}}%",
  "pdf.loading.opening": "Pagina {{page}} - Document laden...",
  "pdf.loading.rendering": "Pagina {{page}} - Renderen... {{percent}}%",
  "pdf.loading.failed": "Pagina {{page}} - Renderen mislukt",
  "pdf.loading.document": "Document laden...",
  "pdf.debug.yes": "Ja",
  "pdf.debug.no": "Nee",

  // PDF Search
  "pdf.search.placeholder": "Zoeken in PDF...",
  "pdf.search.searching": "Zoeken...",
  "pdf.search.results": "{{current}} van {{total}}",
  "pdf.search.no_results": "Geen resultaten",
  "pdf.search.previous_tooltip": "Vorig resultaat (Shift+Enter)",
  "pdf.search.next_tooltip": "Volgend resultaat (Enter)",
  "pdf.search.close_tooltip": "Zoeken sluiten (Escape)",

  // Chapter Navigator
  "pdf.navigator.toggle": "Hoofdstuknavigatie wisselen",
  "pdf.navigator.page_of": "Pagina {{current}} van {{total}}",
  "pdf.navigator.pages_range": "Pagina's {{start}}-{{end}}",

  "portal.title": "Portaal",
  "portal.language": "Taal",
  "portal.unpublished_changes": "Niet-gepubliceerde wijzigingen",
  "portal.published": "Gepubliceerd",
  "portal.publishing": "Publiceren...",
  "portal.publish": "Publiceren",
  "portal.disable_edit": "Bewerkmodus uitschakelen",
  "portal.enable_edit": "Bewerkmodus inschakelen",
  "portal.loading": "Portaalinhoud laden...",
  "portal.retry": "Opnieuw proberen",
  "portal.no_sections": "Geen secties",
  "portal.section_title": "Sectietitel",
  "portal.version_history": "Versiegeschiedenis",
  "portal.hide": "Verbergen",
  "portal.loading_versions": "Laden...",
  "portal.no_versions": "Geen eerdere versies",
  "portal.restore": "Herstellen",
  "portal.show_version_history": "Toon versiegeschiedenis",
  "portal.saving": "Opslaan...",
  "portal.save": "Opslaan",
  "portal.cancel": "Annuleren",
  "portal.no_content": "Geen inhoud",
  "portal.select_section": "Selecteer een hoofdstuk en sectie",
  "portal.add_chapter": "Hoofdstuk toevoegen",
  "portal.add_section": "Sectie toevoegen",
  "portal.close": "Sluiten",
  "portal.save_ordering": "Volgorde opslaan",
  "portal.sections": "Secties",

  "redirect.title": "Nieuw Webadres",
  "redirect.message": "Het Universal Voice Portaal is verhuisd naar een nieuw adres! Je gebruikt nu een oud domein.",
  "redirect.login_notice": "Zodra je op OK klikt, sturen we je door naar het nieuwe adres. Het kan zijn dat je opnieuw moet inloggen.",
  "redirect.ok": "OK",

  "passkey.sign_in": "Inloggen met passkey",
  "passkey.register": "Account aanmaken met passkey",
  "passkey.manage_title": "Passkeys beheren",
  "passkey.manage_desc": "Voeg een passkey toe om snel en veilig in te loggen zonder wachtwoord.",
  "passkey.add": "Passkey toevoegen",
  "passkey.name_placeholder": "Naam voor passkey (bijv. 'Mijn telefoon')",
  "passkey.default_name": "Mijn passkey",
  "passkey.error": "Passkey fout: {{error}}",
  "passkey.error.not_allowed": "Geannuleerd of time-out verlopen.",
  "passkey.error.already_registered": "Deze passkey is al geregistreerd op dit apparaat.",
  "passkey.error.not_supported": "Niet ondersteund op dit apparaat of in deze browser.",
  "passkey.error.security": "Kan alleen worden gebruikt via een beveiligde verbinding (HTTPS).",
  "passkey.error.no_matching_credential": "Niet herkend of hoort niet bij dit account.",
  "passkey.error.account_exists": "Er bestaat al een account met dit e-mailadres. Log eerst in en voeg daarna een passkey toe in je accountinstellingen.",
  "passkey.code.label": "Code uit je e-mail",
  "passkey.code.sent": "We hebben een code van 6 cijfers naar {{email}} gestuurd. Vul die in om je passkey aan te maken.",
  "passkey.code.create": "Passkey aanmaken",
  "passkey.code.email_required": "Vul eerst je e-mailadres in.",
  "passkey.error.invalid_code": "Die code klopt niet. Controleer de e-mail en probeer het opnieuw.",
  "passkey.error.code_expired": "Deze code is verlopen of te vaak geprobeerd. Vraag een nieuwe code aan.",
  "passkey.error.code_wait": "Wacht een minuut voordat je een nieuwe code aanvraagt.",
  "passkey.error.expired_challenge": "Sessie verlopen. Probeer het opnieuw.",
  "passkey.error.unauthorized": "Niet geautoriseerd. Log opnieuw in.",

  "passkey.no_passkeys": "Nog geen passkeys toegevoegd.",

  "login.no-password-set": "Als je je hebt aangemeld met een passkey, gebruik dan de optie 'Inloggen met passkey' hierboven.",
  "registration.passkey-info": "Aanmelden met een passkey stelt geen wachtwoord in. Wil je later een wachtwoord toevoegen? Gebruik dan de optie 'Wachtwoord vergeten' op de inlogpagina.",
  "stemprofiel.title": "Stemprofiel",
  "stemprofiel.updated-days": "Bijgewerkt {{n}} dagen geleden",
  "stemprofiel.updated-today": "Bijgewerkt vandaag",
  "stemprofiel.updated-yesterday": "Bijgewerkt gisteren",
  "stemprofiel.updated-never": "Nog niet ingevuld",
  "stemprofiel.filled": "{{n}}/9 ingevuld",
  "stemprofiel.mode-current": "Huidig",
  "stemprofiel.mode-goal": "Doel",
  "stemprofiel.footer-filled": "{{n}} van 9 dimensies ingevuld",
  "stemprofiel.reset": "Wissen",
  "stemprofiel.save": "Opslaan",
  "stemprofiel.saved-toast": "Stemprofiel opgeslagen",
  "stemprofiel.reset-toast": "Profiel gewist",
  "stemprofiel.reset-confirm": "Alle ingevulde waarden wissen?",
  "tutorial.action.skip": "Overslaan",
  "tutorial.action.prev": "Vorige",
  "tutorial.action.next": "Volgende",
  "tutorial.action.finish": "Afronden",
  "tutorial.dont_show": "Niet meer tonen",
  "tutorial.cancel_confirm": "Weet je zeker dat je de uitleg wilt stoppen?",
  "tutorial.settings.title": "Uitleg & Help",
  "tutorial.settings.reset_all": "Alle uitleg resetten",
  "tutorial.settings.reset_success": "Uitleg succesvol gereset!",
  "tutorial.manage_tags.intro.title": "Tags beheren",
  "tutorial.manage_tags.intro.content": "Welkom bij Tagbeheer! Hier kun je tags organiseren en aanpassen om je Voice Plans te categoriseren.",
  "tutorial.manage_tags.create.title": "Nieuwe tags maken",
  "tutorial.manage_tags.create.content": "Typ hier een tagnaam en druk op Enter of klik op de '+'-knop om een nieuwe aangepaste tag aan te maken.",
  "tutorial.manage_tags.favorite.title": "Vastzetten op navigatie",
  "tutorial.manage_tags.favorite.content": "Klik op het ster-icoon om tags vast te zetten. Vastgezette tags verschijnen als snel-filtertabbladen op je dashboard.",
  "tutorial.manage_tags.color.title": "Kleuren aanpassen",
  "tutorial.manage_tags.color.content": "Klik op de kleurencirkel om een unieke kleur voor deze tag te kiezen. De tags en tabbladen krijgen deze kleur.",
  "tutorial.manage_tags.edit.title": "Tags hernoemen",
  "tutorial.manage_tags.edit.content": "Klik op het potlood-icoon om de weergavenaam van een tag aan te passen. Vastgezette tabbladen tonen deze naam.",
  "tutorial.manage_tags.system.title": "Systeemtags",
  "tutorial.manage_tags.system.content": "Vink dit vakje aan om gereserveerde tags (zoals Leerlingen en Docenten) te verbergen en je te concentreren op je eigen tags.",
  "tutorial.dashboard.quick_filters.title": "Aanpasbare snelfilters",
  "tutorial.dashboard.quick_filters.content": "Welkom op je nieuwe Voice Plans dashboard! Vastgezette tags verschijnen hier nu als snelfilter-tabbladen zodat je direct kunt schakelen.",
  "tutorial.dashboard.tab_all.title": "Alle Voice Plans",
  "tutorial.dashboard.tab_all.content": "Het 'Alles'-tabblad blijft altijd hier staan om je een compleet overzicht te geven van al je Voice Plans.",
  "tutorial.dashboard.search_btn.title": "Zoeken op naam",
  "tutorial.dashboard.search_btn.content": "Klik op het zoekicoon om een zoekveld te openen en je Voice Plans te filteren op naam.",
  "tutorial.dashboard.gear_btn.title": "Tags beheren",
  "tutorial.dashboard.gear_btn.content": "Klik op het tandwiel om de Tag Manager te openen. Hier maak je nieuwe tags aan, stel je kleuren in en kies je welke tags als tabblad bovenaan verschijnen (ster-icoon).",
  "tutorial.dashboard.tag_toggles.title": "Filteren op meerdere tags",
  "tutorial.dashboard.tag_toggles.content": "Selecteer een of meer tags in deze balk om je Voice Plans te filteren. Alleen plannen met deze tags worden getoond.",
  "tutorial.dashboard.edit_tags.title": "Voice Plan-tags bewerken",
  "tutorial.dashboard.edit_tags.content": "We hebben de tag-editor voor dit Voice Plan geopend. Klik op tags om ze toe te voegen of te verwijderen. Houd een Voice Plan lang gedrückt om dit menu te openen.",
  "faq.tours.title": "Interactieve Rondleidingen",
  "faq.tours.intro": "Hulp nodig om op weg te komen? Start een interactieve rondleiding om je in realtime wegwijs te maken in de applicatie.",
  "faq.tours.dashboard.title": "Dashboard Onboarding",
  "faq.tours.dashboard.description": "Ontdek hoe de nieuwe snelfilters, aanpasbare tabbladen en tag-opties werken.",
  "faq.tours.dashboard.button": "Start Dashboard Tour",
  "faq.tours.tags.title": "Tagbeheer Gids",
  "faq.tours.tags.description": "Leer hoe je tags aanmaakt, inkleurt, hernoemt en vastzet op je dashboardnavigatie.",
  "faq.tours.tags.button": "Start Tagbeheer Tour",

  "tutorial.create_vp.step1_intro.title": "Stap-voor-stap een Voice Plan maken",
  "tutorial.create_vp.step1_intro.content": "Laten we een nieuw Voice Plan maken. Deze rondleiding helpt u stap-voor-stap door het proces.",
  "tutorial.create_vp.step1_name.title": "Naam van het Voice Plan",
  "tutorial.create_vp.step1_name.content": "Voer een duidelijke naam in voor uw Voice Plan, zoals 'Belting Progressie van Hans' of 'Mijn Klassieke Oefeningen'.",
  "tutorial.create_vp.step1_next.title": "Volgende Stap",
  "tutorial.create_vp.step1_next.content": "Klik hier om door te gaan naar de volgende stap om tags toe te voegen.",
  "tutorial.create_vp.step2_tags.title": "Organiseer met Tags",
  "tutorial.create_vp.step2_tags.content": "Voeg tags toe om uw Voice Plans later makkelijk te kunnen organiseren en filteren. Typ een tag en druk op Enter.",
  "tutorial.create_vp.step2_quick.title": "Snelle Categorieën",
  "tutorial.create_vp.step2_quick.content": "U kunt ook snel uw favoriete gepinde tags toevoegen door er hier op te klikken.",
  "tutorial.create_vp.step2_next.title": "Doorgaan",
  "tutorial.create_vp.step2_next.content": "Klik hier om de gegevens van uw nieuwe Voice Plan te controleren.",
  "tutorial.create_vp.step3_review.title": "Gegevens controleren",
  "tutorial.create_vp.step3_review.content": "Neem een moment om te controleren of de naam en gekozen tags correct zijn.",
  "tutorial.create_vp.step3_submit.title": "Voice Plan maken",
  "tutorial.create_vp.step3_submit.content": "Klik hier om uw nieuwe Voice Plan definitief aan te maken in de database.",
  "tutorial.create_vp.step4_invite.title": "Mensen uitnodigen",
  "tutorial.create_vp.step4_invite.content": "U kunt dit Voice Plan delen met anderen door hun e-mailadres in te vullen. Zij ontvangen dan een uitnodiging.",
  "tutorial.create_vp.step4_done.title": "Helemaal klaar!",
  "tutorial.create_vp.step4_done.content": "Klik hier om de rondleiding af te ronden en uw nieuw gemaakte Voice Plan te openen!",

  "faq.tours.create_vp.title": "Voice Plan maken rondleiding",
  "faq.tours.create_vp.description": "Stap-voor-stap handleiding voor het maken van een nieuw Voice Plan, het toevoegen van tags en het uitnodigen van anderen.",
  "faq.tours.create_vp.button": "Start Rondleiding",

  "tutorial.playlist_list.intro.title": "Afspeellijsten bibliotheek",
  "tutorial.playlist_list.intro.content": "Welkom bij je afspeellijsten! Hier kun je aangepaste oefensessies samenstellen met oefeningen.",
  "tutorial.playlist_list.create.title": "Afspeellijst maken",
  "tutorial.playlist_list.create.content": "Klik op deze knop om een nieuwe afspeellijst te maken. Je wordt gevraagd een naam in te voeren.",
  "tutorial.playlist_detail.intro.title": "Je afspeellijst",
  "tutorial.playlist_detail.intro.content": "Dit is het detailoverzicht van je afspeellijst. Hier kun je de audio-items in je oefenroutine beheren en ze achter elkaar afspelen.",
  "tutorial.playlist_detail.edit.title": "Afspeellijst bewerken",
  "tutorial.playlist_detail.edit.content": "Schakel de bewerkingsmodus in om je afspeellijst aan te passen. Hier kun je items toevoegen, verwijderen of slepen om de volgorde te wijzigen.",
  "tutorial.playlist_detail.add_item.title": "Audio-items toevoegen",
  "tutorial.playlist_detail.add_item.content": "Klik hier om zangoefeningen aan je afspeellijst toe te voegen.",
  "tutorial.playlist_detail.share.title": "Afspeellijst delen",
  "tutorial.playlist_detail.share.content": "Klik hier om deze afspeellijst met anderen te delen. Je kunt hem openbaar maken of rechtstreeks delen met docenten en leerlingen.",
  "faq.tours.playlist.title": "Afspeellijsten Gids",
  "faq.tours.playlist.description": "Leer hoe je een afspeellijst maakt, oefeningen toevoegt, de volgorde aanpast en deze deelt.",
  "faq.tours.playlist.button": "Start Afspeellijsten Tour",
  "admin.impersonating": "Imiteert gebruiker {{name}}",
  "admin.stop-impersonation": "Stop Impersonatie",

  "organization.title": "Organisatie Licentie",
  "organization.create.subtitle": "Koop een pool van abonnementsplaatsen voor je school, bedrijf of koor. Beheer alle licenties, leden en verlengingen in één centrale portal.",
  "organization.create.name_label": "Organisatienaam",
  "organization.create.name_placeholder": "bijv. Koninklijke Academie voor Muziek",
  "organization.create.seats_label": "Aantal plaatsen (min. 10)",
  "organization.create.interval_label": "Factureringsinterval",
  "organization.create.interval_monthly": "Maandelijks (€9,95 / plaats / maand)",
  "organization.create.interval_yearly": "Jaarlijks (€99,50 / plaats / jaar - 2 maanden gratis!)",
  "organization.create.submit": "Aanmaken & Doorgaan naar Verificatiebetaling",
  "organization.create.note": "Let op: Je wordt doorgestuurd naar Mollie om je betaling af te ronden. Toekomstige abonnementskosten worden automatisch afgeschreven.",
  "organization.create.modal_title": "Nieuwe Organisatie Licentie",
  "organization.create.modal_subtitle": "Koop een pool van abonnementsplaatsen voor je team.",
  "organization.create.modal_submit": "Aanmaken & Doorgaan",
  "organization.dashboard.active_organization": "Actieve Organisatie",
  "organization.dashboard.title": "Organisatie Dashboard",
  "organization.dashboard.new_organization": "Nieuwe Organisatie",
  "organization.dashboard.admin_label": "Beheerder: {{email}}",
  "organization.dashboard.manage_admins": "Beheerders Beheren",
  "organization.dashboard.billing_details": "Factuurgegevens",
  "organization.dashboard.view_invoices_and_details": "Facturen & Factuurgegevens",
  "organization.invoices.title": "Facturen & Factuurgegevens",
  "organization.invoices.subtitle": "Beheer uw factuuradres, BTW- en KvK-nummer en bekijk alle facturen van uw organisatie.",
  "organization.invoices.billing_form_title": "Factuurgegevens & Adres",
  "organization.invoices.billing_form_desc": "Stel de gegevens in die op uw officiële facturen worden vermeld.",
  "organization.invoices.company_name": "Bedrijfsnaam op factuur",
  "organization.invoices.billing_email": "Factuur e-mailadres",
  "organization.invoices.billing_email_help": "Facturen en betalingsbevestigingen worden automatisch naar dit adres gestuurd.",
  "organization.invoices.street": "Straat en huisnummer",
  "organization.invoices.postcode": "Postcode",
  "organization.invoices.city": "Plaats",
  "organization.invoices.country": "Land",
  "organization.invoices.kvk_number": "KvK-nummer (optioneel)",
  "organization.invoices.vat_number": "BTW-nummer (optioneel)",
  "organization.invoices.save_button": "Factuurgegevens opslaan",
  "organization.invoices.save_success": "Factuurgegevens succesvol bijgewerkt.",
  "organization.invoices.list_title": "Facturetoverzicht",
  "organization.invoices.no_invoices": "Nog geen facturen beschikbaar.",
  "organization.invoices.invoice_nr": "Factuurnr.",
  "organization.invoices.date": "Datum",
  "organization.invoices.description": "Omschrijving",
  "organization.invoices.amount": "Bedrag",
  "organization.invoices.download_pdf": "Download PDF",
  "organization.dashboard.billing_desc_monthly": "Maandelijkse Organisatie Licentie",
  "organization.dashboard.billing_desc_yearly": "Jaarlijks Organisatie Licentie",
  "organization.dashboard.price_per_seat": "Prijs per plaats: €{{price}}",
  "organization.dashboard.next_renewal": "Volgende verlenging: {{date}}",
  "organization.dashboard.pending_downgrade_notice": "Een vermindering naar {{count}} plaatsen staat gepland voor de volgende verlengingsdatum ({{date}}).",
  "organization.dashboard.seat_usage": "Plaatsgebruik",
  "organization.dashboard.seats_assigned": "van de {{total}} plaatsen toegewezen",
  "organization.dashboard.seats_remaining": "{{count}} plaatsen over",
  "organization.dashboard.assignment_movements": "{{count}} toewijzingsbewegingen",
  "organization.dashboard.modify_seats": "Aantal Plaatsen Aanpassen",
  "organization.dashboard.modify_seats_desc": "Verhoog of verlaag de totale pool van plaatsen. Verlagen kan niet onder het aantal toegewezen plaatsen ({{usedSeats}}) vallen.",
  "organization.dashboard.enterprise_seats_managed": "Het aantal plaatsen voor enterprise-licenties wordt beheerd door Universal Voice. Neem contact op met uw accountmanager om het aantal plaatsen te wijzigen.",
  "organization.dashboard.enterprise_seats_title": "Plaatsenpool",
  "organization.dashboard.update_button": "Bijwerken",
  "organization.dashboard.seat_assignments": "Plaatsstoewijzingen",
  "organization.dashboard.users": "Gebruikers",
  "organization.dashboard.no_users": "Nog geen gebruikers toegewezen.",
  "organization.dashboard.assign_seat_button": "Plaats Toewijzen",
  "organization.dashboard.assign_seat_placeholder": "gebruiker@voorbeeld.nl",
  "organization.dashboard.seat_id": "Plaats ID",
  "organization.dashboard.assigned_user": "Toegewezen Gebruiker",
  "organization.dashboard.date_assigned": "Toewijzingsdatum",
  "organization.dashboard.action": "Actie",
  "organization.dashboard.pending_signup": "Wacht op registratie",
  "organization.dashboard.unassigned": "Niet toegewezen (Open plaats)",
  "organization.dashboard.revoke_seat": "Plaats Intrekken",
  "organization.dashboard.ready": "Gereed",
  "organization.dashboard.search_seats_placeholder": "Zoek licentie op e-mailadres of ID...",
  "organization.dashboard.clear_search": "Zoekopdracht wissen",
  "organization.dashboard.search_prompt": "Typ een e-mailadres of ID om een specifieke licentie te zoeken en te beheren.",
  "organization.dashboard.no_seats_found": "Geen licenties gevonden die voldoen aan de zoekopdracht.",
  "organization.admins.title": "Beheerders Beheren",
  "organization.admins.subtitle": "Beheer wie de licentie van deze organisatie kan beheren en plaatsen kan toewijzen.",
  "organization.admins.add_admin": "Beheerder Toevoegen",
  "organization.admins.email_address": "E-mailadres",
  "organization.admins.role": "Rol",
  "organization.admins.action": "Actie",
  "organization.admins.owner": "Eigenaar",
  "organization.admins.co_admin": "Mede-beheerder",
  "organization.admins.remove": "Verwijderen",
  "common.error": "Fout",
  "admin.organizations.title": "Organisaties",
  "admin.organizations.create_enterprise": "Nieuwe Enterprise Organisatie",
  "admin.organizations.search_placeholder": "Zoek op naam, e-mail of ID...",
  "admin.organizations.name": "Naam",
  "admin.organizations.type": "Type",
  "admin.organizations.status": "Status",
  "admin.organizations.admins": "Beheerders",
  "admin.organizations.seats": "Licenties",
  "admin.organizations.actions": "Acties",
  "admin.organizations.activate": "Activeren",
  "admin.organizations.suspend": "Schorsen",
  "admin.organizations.active": "Actief",
  "admin.organizations.suspended": "Geschorst",
  "admin.organizations.pending": "In afwachting van betaling",
  "admin.organizations.enterprise": "Enterprise",
  "admin.organizations.mollie_monthly": "Mollie Maandelijks",
  "admin.organizations.mollie_yearly": "Mollie Jaarlijks",
  "admin.organizations.create_modal_title": "Nieuwe Enterprise Organisatie Aanmaken",
  "admin.organizations.create_modal_desc": "Maak een enterprise organisatie aan. Enterprise licenties worden handmatig buiten Mollie om gefactureerd.",
  "admin.organizations.admin_email_label": "Beheerder E-mailadres (bestaande gebruiker)",
  "admin.organizations.seats_label": "Aantal licenties",
  "admin.organizations.edit_seats": "Licenties Aanpassen",
  "admin.organizations.no_orgs_found": "Geen organisaties gevonden",
  "admin.organizations.total_orgs": "Totaal Organisaties",
  "admin.organizations.total_seats": "Totaal Licenties",
  "admin.organizations.active_seats": "Toegewezen Licenties",
  "admin.email_templates.title": "Systeem E-mail Events",
  "admin.email_templates.subtitle": "Configureer e-mailsjablonen en actieve versies voor systeemevents.",
  "admin.email_templates.search_placeholder": "Zoek op naam, ID, categorie of omschrijving...",
  "admin.email_templates.event": "Event",
  "admin.email_templates.category": "Categorie",
  "admin.email_templates.active_version": "Actieve Versie",
  "admin.email_templates.languages": "Talen",
  "admin.email_templates.actions": "Acties",
  "admin.email_templates.no_events_found": "Geen e-mailsjablonen gevonden",
  "admin.email_templates.history": "Geschiedenis",
  "admin.email_templates.edit_template": "Sjabloon Bewerken",
  "admin.email_templates.not_configured": "Niet geconfigureerd",
  "organization.list.subtitle": "Beheer je organisatielicenties en toegewezen plaatsen",
  "organization.list.back_to_list": "Terug naar Organisaties",

  "pricing.title": "Geef Jouw Stem De Ruimte Om Te Groeien",
  "pricing.subtitle": "Of je nu alleen thuis zingt, zanglessen volgt of een koor leidt. Digital PVP biedt de ideale gids en inzingoefeningen op elk moment.",
  "pricing.billing.monthly": "Maandelijks",
  "pricing.billing.quarterly": "Driemaandelijks",
  "pricing.billing.yearly": "Jaarlijks",
  "pricing.billing.save_percent": "Bespaar {{percent}}%",
  "pricing.billing.guarantee": "14 Dagen Gratis Proberen • Geen Creditcard Nodig",

  "pricing.value.v1_title": "Vrij Inzingen & Oefenen",
  "pricing.value.v1_desc": "Oefen op jouw eigen tempo en gewenste toonhoogte",
  "pricing.value.v2_title": "Universal Voice Guide",
  "pricing.value.v2_desc": "Altijd de officiële studieboeken en technieken bij de hand",
  "pricing.value.v3_title": "Stemprofiel & Voortgang",
  "pricing.value.v3_desc": "Houd je stembereik en persoonlijke ontwikkeling bij",
  "pricing.value.v4_title": "Docent Lesplannen",
  "pricing.value.v4_desc": "Ontvang maatwerk lesplannen van je zangdocent",

  "pricing.free.title": "Gratis Account",
  "pricing.free.badge": "GRATIS STARTEN",
  "pricing.free.price": "€0",
  "pricing.free.period": "vrijblijvend proberen",
  "pricing.free.description": "Perfect om te starten. Oefen met gratis standaard inzinglesplannen en ontdek het platform.",
  "pricing.free.cta": "Gratis Account Aanmaken",
  "pricing.free.f1": "Standaard proeflesplannen (Gratis categorie)",
  "pricing.free.f2": "Toegang tot gratis basis inzingoefeningen",
  "pricing.free.f3": "Oefenen via de webbrowser op elk apparaat",

  "pricing.pro.title": "Pro Abonnement",
  "pricing.pro.badge_yearly": "MEEST GEKOZEN • BESTE WAARDE",
  "pricing.pro.badge_quarterly": "SLIMME KEUZE",
  "pricing.pro.badge_monthly": "FLEXIBEL ABONNEMENT",
  "pricing.pro.description": "Onbeperkt toegang tot alle zangoefeningen, lesplannen van je docent en handige functies voor dagelijkse training.",
  "pricing.pro.cta": "Start 14 Dagen Gratis Proefperiode",
  "pricing.pro.f1": "Ontvang & gebruik lesplannen van je zangdocent/dirigent",
  "pricing.pro.f2": "Onbeperkt alle zangoefeningen afspelen",
  "pricing.pro.f3": "Pas tempo en toonhoogte aan naar jouw stem",
  "pricing.pro.f4": "Volledige digitale Universal Voice Guide boeken (PDF)",
  "pricing.pro.f5": "Zelf onbeperkt Voice Plans & afspeellijsten maken",
  "pricing.pro.f6": "Eigen Stemprofiel aanmaken en voortgang bijhouden",
  "pricing.pro.f7": "Prioritaire ondersteuning bij al je vragen",

  "pricing.matrix.title": "Vergelijk Alle Functies",
  "pricing.matrix.cat_basics": "Basis & Warm-ups",
  "pricing.matrix.cat_exercises": "Zangoefeningen & Audio",
  "pricing.matrix.cat_plans": "Lesplannen & Docenten",
  "pricing.matrix.cat_books": "Studieboeken & PDF",
  "pricing.matrix.cat_apps": "Apps & Offline",
  "pricing.matrix.item_starter_exercises": "Gratis inzingoefeningen",
  "pricing.matrix.item_all_exercises": "Volledige oefeningencatalogus",
  "pricing.matrix.item_pitch_tempo": "Tempo & toonhoogte aanpassen",
  "pricing.matrix.item_starter_plans": "Standaard proeflesplannen (Gratis categorie)",
  "pricing.matrix.item_teacher_plans": "Lesplannen van je zangdocent/dirigent ontvangen",
  "pricing.matrix.item_create_plans": "Zelf Voice Plans & playlists maken",
  "pricing.matrix.item_stemprofiel": "Persoonlijk Stemprofiel aanmaken & bijhouden",
  "pricing.matrix.item_book_previews": "Studieboeken voorbeeldpagina's",
  "pricing.matrix.item_full_books": "Alle Universal Voice Guide boeken (PDF)",
  "pricing.matrix.item_offline_apps": "Offline oefenmodus (Mobiel & Desktop)",
  "pricing.matrix.val_limited": "Basisselectie",
  "pricing.matrix.val_full": "Volledige Toegang",
  "pricing.matrix.val_previews": "Geen toegang",
  "pricing.matrix.val_all_books": "Alle Boeken",
  "pricing.matrix.val_default_only": "Alleen Standaard Proefplannen",
  "pricing.matrix.val_teacher_unlimited": "Volledig (Docent & Maatwerk)",
  "pricing.matrix.val_unlimited": "Onbeperkt Maken",
  "pricing.matrix.val_online_only": "Alleen Online",
  "pricing.matrix.val_full_offline": "Volledig Offline",
  "pricing.matrix.val_no_access": "Niet inbegrepen",
  "pricing.matrix.val_pro_only": "Inbegrepen bij Pro",

  "pricing.org_teaser.title": "Geef Je Koor, Zangstudio of School Een Boost",
  "pricing.org_teaser.subtitle": "Werk samen met je leerlingen of koorleden. Deel lesplannen, beheer licenties centraal en ontvang groepskorting.",
  "pricing.org_teaser.cta": "Bekijk Organisatie Licenties",
  "pricing.faq.title": "Veelgestelde Vragen Over Prijzen",
  "pricing.faq.q1": "Kan ik mijn abonnement op elk moment opzeggen?",
  "pricing.faq.a1": "Ja, absoluut! Je kunt je abonnement met één klik opzeggen via je accountinstellingen. Je behoudt volledige toegang tot het einde van je al betaalde periode.",
  "pricing.faq.q2": "Hoe werkt de 14 dagen gratis proefperiode?",
  "pricing.faq.a2": "Wanneer je je proefperiode start, krijg je direct 14 dagen toegang tot alle Pro-functies. Je kunt oefeningen testen, afspeellijsten maken en digitale boeken inzien. Je wordt pas na 14 dagen gefactureerd als je kiest om door te gaan.",
  "pricing.faq.q3": "Op welke apparaten kan ik Digital PVP gebruiken?",
  "pricing.faq.a3": "Digital PVP is toegankelijk via je webbrowser op al je apparaten: je smartphone, tablet, laptop of desktop computer.",
  "pricing.faq.q4": "Wat is het verschil tussen een gratis account en een Pro abonnement?",
  "pricing.faq.a4": "Met een gratis account oefen je met onze gratis standaard inzinglesplannen. Om lesplannen en huiswerk van jouw eigen zangdocent of dirigent te ontvangen, je eigen Stemprofiel bij te houden of zelf onbeperkt lesplannen te maken, is een Pro abonnement of Organisatie licentie vereist.",

  "pricing_org.title": "Organisatie & Institutionele Licenties",
  "pricing_org.subtitle": "Geef je koor, zangpraktijk, muziekschool of conservatorium toegang met meerdere licenties, gedeelde lesplannen en beheerdersfuncties.",
  "pricing_org.switch_individual": "Zoek je een individueel abonnement? Bekijk Persoonlijke Plannen",
  "pricing_org.tier_ensemble.title": "Klein Koor & Ensemble",
  "pricing_org.tier_ensemble.seats": "5 – 15 Lidlicenties",
  "pricing_org.tier_ensemble.price": "€4,50",
  "pricing_org.tier_ensemble.period": "per licentie / maand (jaarlijks gefactureerd)",
  "pricing_org.tier_ensemble.desc": "Ideaal voor zanggroepen, kwartetten en kleine koren die samen oefenen.",
  "pricing_org.tier_ensemble.cta": "Start Groepslicentie",
  "pricing_org.tier_school.title": "Muziekschool & Zangstudio",
  "pricing_org.tier_school.badge": "AANBEVOLEN VOOR SCHOLEN",
  "pricing_org.tier_school.seats": "16 – 50 Licenties (Docenten & Studenten)",
  "pricing_org.tier_school.price": "€3,50",
  "pricing_org.tier_school.period": "per licentie / maand (jaarlijks gefactureerd)",
  "pricing_org.tier_school.desc": "Volledig zanglesplatform met studenttoewijzing, gedeelde Voice Plans en centrale facturatie.",
  "pricing_org.tier_school.cta": "Muziekschool Instellen",
  "pricing_org.tier_enterprise.title": "Conservatorium & Enterprise",
  "pricing_org.tier_enterprise.badge": "ENTERPRISE NIVEAU",
  "pricing_org.tier_enterprise.seats": "50+ Licenties / Onbeperkte Schaal",
  "pricing_org.tier_enterprise.price": "Offerte op Maat",
  "pricing_org.tier_enterprise.period": "voorwaarden & facturatie op maat",
  "pricing_org.tier_enterprise.desc": "Voor conservatoria, universitaire zangafdelingen, landelijke koorfederaties en grote onderwijsinstellingen.",
  "pricing_org.tier_enterprise.cta": "Neem Contact Op voor Enterprise",
  "pricing_org.features.title": "Voordelen van Organisatie Licenties",
  "pricing_org.features.f1": "Centraal beheerdashboard voor lid- en licentiebeheer",
  "pricing_org.features.f2": "Maak en wijs aangepaste Voice Plans en oefeningen toe aan studenten",
  "pricing_org.features.f3": "Gedeelde repertoire-bibliotheken en repetitie-afspeellijsten",
  "pricing_org.features.f4": "Flexibele centrale facturatie, PO-ondersteuning en BTW-facturen",
  "pricing_org.features.f5": "Dedicated Account Manager & onboarding ondersteuning",
  "pricing_org.features.f6": "Opties voor custom SSO (Single Sign-On) & LMS-integratie",
  "pricing_org.form.title": "Neem Contact op met Enterprise Team",
  "pricing_org.form.subtitle": "Vul het onderstaande formulier in en ons team neemt binnen 24 uur contact met je op met een passende offerte.",
  "pricing_org.form.org_name": "Organisatienaam",
  "pricing_org.form.contact_name": "Contactpersoon",
  "pricing_org.form.email": "Zakelijk E-mailadres",
  "pricing_org.form.seats": "Geschat Aantal Licenties",
  "pricing_org.form.type": "Type Organisatie",
  "pricing_org.form.type_choir": "Koor / Zanggroep",
  "pricing_org.form.type_school": "Zangpraktijk / Muziekschool",
  "pricing_org.form.type_conservatory": "Conservatorium / Universiteit",
  "pricing_org.form.type_other": "Overige Instelling",
  "pricing_org.form.message": "Vertel ons meer over je wensen",
  "pricing_org.form.submit": "Enterprise Aanvraag Versturen",
  "pricing_org.form.success_title": "Aanvraag Ontvangen!",
  "pricing_org.form.success_desc": "Bedankt voor je aanvraag. Een Universal Voice specialist neemt zo snel mogelijk contact met je op.",

  "pricing.head.title": "Prijzen & Productoverzicht - Digital PVP",
  "pricing.head.description": "Kies het abonnement dat bij jouw stem en doelstellingen past. Gratis starten of 14 dagen gratis proberen.",
  "pricing.nav.individual": "Individueel",
  "pricing.nav.organization": "Koren & Instellingen",
  "pricing.billing.monthly_period": "/ mnd",
  "pricing.billing.monthly_note": "Maandelijks opzegbaar",
  "pricing.billing.quarterly_note": "€18,00 per kwartaal gefactureerd (-14%)",
  "pricing.billing.yearly_note": "€60,00 per jaar gefactureerd (-28%)",
  "pricing.billing.best_deal": "-28% • Beste deal",
  "pricing.billing.savings_badge": "Bespaar {{amount}}",
  "pricing.billing.savings_yearly": "Je bespaart €24,- per jaar (-28% korting)",
  "pricing.billing.savings_quarterly": "Je bespaart €12,- per jaar (-14% korting)",
  "pricing.billing.savings_monthly": "Maximale flexibiliteit • Maandelijks opzegbaar",
  "pricing.audio.tooltip": "Beluister klankvoorbeeld van het platform",
  "pricing.audio.pause": "Pauzeer klank",
  "pricing.audio.play": "Beluister klankharmonie",
  "pricing.free.sub": "Ideaal om te ontdekken",
  "pricing.free.no_payment": "Geen betaalgegevens of verplichtingen vereist",
  "pricing.free.includes": "Inbegrepen in Gratis:",
  "pricing.pro.sub": "Voor serieuze zangers & studenten",
  "pricing.pro.includes": "Alles uit Gratis plus:",
  "pricing.trust.trial": "14 Dagen Vrijblijvend Proberen",
  "pricing.trust.cancel": "Op Elk Moment Opzegbaar",
  "pricing.trust.secure": "Veilig via iDEAL, Creditcard & Apple Pay",
  "pricing.matrix.subtitle": "Vergelijk alle mogelijkheden en vind het perfecte pakket",
  "pricing.matrix.search_placeholder": "Zoek functie...",
  "pricing.matrix.clear_search": "Wis zoekopdracht",
  "pricing.matrix.filter_all": "Alles",
  "pricing.matrix.filter_plans": "Lesplannen",
  "pricing.matrix.filter_exercises": "Oefeningen",
  "pricing.matrix.header_feature": "Functie",
  "pricing.matrix.empty_search": "Geen functies gevonden voor \"{{query}}\"",
  "pricing.matrix.tooltip.starter_plans": "Ontvang direct digitale lesplannen toegewezen door je docent",
  "pricing.matrix.tooltip.teacher_plans": "Gebruik alle lesstructuren uit de Universal Voice Methode",
  "pricing.matrix.tooltip.create_plans": "Stel je eigen gepersonaliseerde inzing- en oefenroutines samen",
  "pricing.matrix.tooltip.starter_exercises": "Gratis selectie van basis inzingoefeningen",
  "pricing.matrix.tooltip.all_exercises": "Toegang tot het volledige archief van meer dan 500+ zangoefeningen",
  "pricing.matrix.tooltip.pitch_tempo": "Verander de toonsoort en het tempo in de speler naar jouw stembereik",
  "pricing.matrix.tooltip.stemprofiel": "Leg je stembereik, stemtype en persoonlijke zangdoelen vast",
  "pricing.matrix.tooltip.books_access": "Digitale Universal Voice Guide handboeken inbegrepen",
  "pricing.org_teaser.badge": "Koren & Scholen",
  "pricing.faq.subtitle": "Antwoorden op de meest gestelde vragen",
  "pricing_org.head.title": "Organisatie Licenties & Enterprise - Digital PVP",
  "pricing_org.head.description": "Groepslicenties voor koren, zangpraktijken, muziekscholen en conservatoria. Beheer meerdere licenties, gedeelde lesplannen en centrale facturatie.",
  "pricing_org.tier_ensemble.f1": "5 t/m 15 lidlicenties met Pro toegang",
  "pricing_org.tier_ensemble.f2": "Centraal beheerdersaccount voor dirigent/leider",
  "pricing_org.tier_ensemble.f3": "Gedeelde koor-afspeellijsten & Voice Plans",
  "pricing_org.tier_ensemble.f4": "Jaarlijkse automatische facturatie",
  "pricing_org.tier_school.f1": "16 t/m 50 student- & docentlicenties",
  "pricing_org.tier_school.f2": "Wijs Voice Plans en opdrachten toe aan studenten",
  "pricing_org.tier_school.f3": "Meerdere docentenaccounts & beheerders",
  "pricing_org.tier_school.f4": "Flexibel licenties toevoegen gedurende het jaar",
  "pricing_org.tier_school.f5": "Prioritaire e-mailondersteuning",
  "pricing_org.tier_enterprise.f1": "50+ tot onbeperkte licenties",
  "pricing_org.tier_enterprise.f2": "Custom SSO (Single Sign-On) & LMS-koppeling",
  "pricing_org.tier_enterprise.f3": "Eigen onderwijscurriculum & zangmateriaal digitaliseren",
  "pricing_org.tier_enterprise.f4": "Facturatie op rekening (PO / Invoicing)",
  "pricing_org.tier_enterprise.f5": "Dedicated Account Manager & SLA afspraken",
  "pricing_org.features.f1_title": "Centraal Beheer",
  "pricing_org.features.f2_title": "Voice Plans Toewijzen",
  "pricing_org.features.f3_title": "Gedeeld Repertoire",
  "pricing_org.features.f4_title": "Flexibele Facturatie",
  "pricing_org.features.f5_title": "Dedicated Support",
  "pricing_org.features.f6_title": "SSO & LMS Opties",
  "pricing_org.form.org_name_placeholder": "Bijv. Conservatorium van Amsterdam",
  "pricing_org.form.contact_name_placeholder": "Naam",
  "pricing_org.form.email_placeholder": "email@organisatie.nl",
  "pricing_org.form.seats_15_50": "15 – 50 licenties",
  "pricing_org.form.seats_50_100": "50 – 100 licenties",
  "pricing_org.form.seats_100_250": "100 – 250 licenties",
  "pricing_org.form.seats_250_plus": "250+ licenties (Unlimited)",
  "pricing_org.form.message_placeholder": "Omschrijf de wensen of specifieke vragen voor jouw instelling...",
  "pricing_org.form.submitting": "Versturen...",
  "pricing_org.calc.badge": "Interactieve Licentie Calculator",
  "pricing_org.calc.title": "Bereken de kosten voor jouw organisatie",
  "pricing_org.calc.seats_label": "licenties",
  "pricing_org.calc.recommended_tier": "Aanbevolen Pakket",
  "pricing_org.calc.rate_per_seat": "Tarief Per Licentie",
  "pricing_org.calc.per_month": "/ mnd",
  "pricing_org.calc.savings_label": "Korting vs Individueel",
  "pricing_org.calc.savings_note": "({{savings}}/jaar besparing)",
  "pricing_org.trust.central_management": "Centraal Lidbeheer",
  "pricing_org.trust.invoice_po": "Facturatie op Rekening (PO)",
  "pricing_org.trust.instant_allocation": "Directe Licentie Toewijzing",
  "pricing_org.trust.gdpr": "AVG & Privacy Proof",
  "pricing_org.features.subtitle": "Ontworpen voor dirigenten, zangdocenten en onderwijsbeheerders.",
  "pricing_org.faq.q1": "Hoe werkt het toewijzen van lidlicenties?",
  "pricing_org.faq.a1": "Als beheerder krijg je toegang tot een centraal beheerdashboard. Hiermee kun je eenvoudig e-mailadressen uitnodigen of CSV-lijsten van koorleden en studenten importeren. Licenties kunnen op elk moment worden overgedragen als leden wisselen.",
  "pricing_org.faq.q2": "Kunnen we betalen via een officiële factuur (PO)?",
  "pricing_org.faq.a2": "Ja! Voor koren, muziekscholen en conservatoria bieden wij betaling op rekening met officiële BTW-facturen en inkoopordernummers (PO). Neem contact op of selecteer factuurbetaling bij het bestellen.",
  "pricing_org.faq.q3": "Kunnen docenten en dirigenten eigen Voice Plans delen?",
  "pricing_org.faq.a3": "Absoluut. Docenten en dirigenten kunnen op maat gemaakte inzingroutines, koorrepetitie-afspeellijsten en opdrachten direct toewijzen aan alle leden of specifieke stemgroepen (Sopraan, Alt, Tenor, Bas).",
  "pricing_org.faq.q4": "Wat gebeurt er als we gedurende het jaar extra licenties nodig hebben?",
  "pricing_org.faq.a4": "Je kunt op elk moment extra licenties toevoegen via het beheerdashboard. De kosten worden naar rato verrekend voor de resterende looptijd van je jaarovereenkomst.",
  "common.select_language": "Taal selecteren"
}